"use strict";

// tweaks these below variable if you want to show subtotal and discount
var showCartSubTotalDiscountSection = false;
var showEmptyCartIcon = false;
var showCartCountInTopNav = true;
var showProgressBar = true;
var showVendorOnCartPage = false;
var enablePlusQuantity = false;
var disablePlusQuantityAfterNumber = 6;
var removeMiniCartTextOrIcon = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g stroke="#37312F" stroke-width="2" fill="none" fill-rule="evenodd" opacity=".5"><path d="m14.243 5.757-8.486 8.486M5.757 5.757l8.486 8.486"/></g></svg>';
var plusIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="22" viewBox="0 0 13 22"><text transform="translate(13 15)" style="fill:#1a1818;font-size:22px;font-family:ITCFranklinGothicStd-Med,ITC Franklin Gothic Std"><tspan x="-12.914" y="0">+</tspan></text></svg>';
var minusIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="22" viewBox="0 0 11 22"> <text transform="translate(11 15)" style="fill:#1a1818;font-size:22px;font-family:ITCFranklinGothicStd-Med,ITC Franklin Gothic Std"><tspan x="-11" y="0">–</tspan></text></svg>'; // Fixed variables

var lineItemComparePrice;
var cartObject;
var cartCountEmptyValue = "0";
var boxID = "_Box ID"; //extra classes for the elements

var removeExtraClass = "btn-border-black-animate";
/* CUSTOM OFFERS */
//black friday main productID

var promoOfferQuantity = 0;
var boolPromoOffer_BlackFriday_ProductID = false; //Replace on LIVE

var promoOffer_BlackFriday_ProductID = "6737920098374";
var promoOffer_BlackFriday_FreeBag_ProductID = "6737924587590"; // recharge 2020

var frequency = "";
var recurringchecked = false;
var frequency_unit = "";
var cartExtraInfo;
$(document).ready(function ($) {
  reloadAjaxCartItemUsingCartAjaxObject();
  progressBar();
  quickCartTotal();
  calculateSubTotalWithDiscount();
  /*cart numeric type*/

  $(".js__cart__quantity-selector").keypress(function (event) {
    var keycode = event.keyCode || event.which;

    if (keycode == "13") {
      event.preventDefault();

      if ($(this).val() == "0") {
        $(this).val("1");
      }

      var lineCount = $(this).attr("data-cart-line-count");
      updateQuantity(lineCount);
      return false;
    }
  });
  /*Monogram message save on keypress*/
  //$(document).on("keypress", ".js__text-monogrammingMessage", function() {

  $(document).on("blur", ".js__text-monogrammingMessage", function () {
    console.log("blur");
    var elementText = $(this);
    var monogrammingMessage = elementText.val();

    if (monogrammingMessage != "") {
      var lineItemCount = elementText.attr("data-lineCount");
      var key = $(this).closest(".js__cart-table-item-row").attr("key");
      var id = $(this).closest(".js__cart-table-item-row").attr("data-variant-id");
      console.log(lineItemCount);
      console.log(key);
      console.log(id);
      var newQuantity = $(this).closest(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
      newQuantity = parseInt(newQuantity);
      console.log(newQuantity);
      var variantId = key; // Replace 'your_variant_id' with the actual variant ID

      var properties = {
        'Monogram Message': monogrammingMessage // Add more properties if needed

      }; // Step 1: Remove the item from the cart

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          quantity: 0,
          // Set the quantity to 0 to remove the item
          id: variantId
        },
        dataType: 'json',
        success: function success() {
          // Step 2: Add the item back to the cart with updated properties
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: newQuantity,
              // Adjust the quantity as needed
              id: id,
              properties: properties
            },
            dataType: 'json',
            success: function success(cart) {
              console.log('Cart updated:', cart);
              getCartData(cart); // Handle successful update here
            },
            error: function error(_error) {
              console.error('Error updating cart:', _error); // Handle error here
            }
          });
        },
        error: function error(_error2) {
          console.error('Error removing item from cart:', _error2); // Handle error here
        }
      });
    }
  });
  $(document).on("blur", ".js__text-engravingMessage", function () {
    console.log("blur");
    var elementText = $(this);
    var engravingMessage = elementText.val();

    if (engravingMessage != "") {
      var lineItemCount = elementText.attr("data-lineCount");
      var key = $(this).closest(".js__cart-table-item-row").attr("key");
      var id = $(this).closest(".js__cart-table-item-row").attr("data-variant-id");
      console.log(lineItemCount);
      console.log(key);
      console.log(id);
      var newQuantity = $(this).closest(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
      newQuantity = parseInt(newQuantity);
      console.log(newQuantity);
      var variantId = key; // Replace 'your_variant_id' with the actual variant ID

      var properties = {
        'Engraving Message': engravingMessage // Add more properties if needed

      }; // Step 1: Remove the item from the cart

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          quantity: 0,
          // Set the quantity to 0 to remove the item
          id: variantId
        },
        dataType: 'json',
        success: function success() {
          // Step 2: Add the item back to the cart with updated properties
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: newQuantity,
              // Adjust the quantity as needed
              id: id,
              properties: properties
            },
            dataType: 'json',
            success: function success(cart) {
              console.log('Cart updated:', cart);
              getCartData(cart); // Handle successful update here
            },
            error: function error(_error3) {
              console.error('Error updating cart:', _error3); // Handle error here
            }
          });
        },
        error: function error(_error4) {
          console.error('Error removing item from cart:', _error4); // Handle error here
        }
      });
    }
  });
});
/*
EVENTS
1. Update quantity
2. minus quantity
3. plus quantity
4. remove item from cart
5. reload ajax cart
6. quickCartTotal
7. calculateSubTotalWithDiscount
8. cart.requestComplete
*/
//QUANTITY UPDATE

function updateQuantity(cartThis) {
  var lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  var itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  var lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  var variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  /* NOTE: you will not get Raw Inventory against the variant in API calls */

  /* PENDING, need to find a solution for this */

  /* Need to check stock levels for the variant 
  as cartJS is giving success even if the stock levels are low and not going into Error*/

  var rawStockVariantQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").attr("data-attr-raw-variant-quantity");
  /* If the new quantity is less then the stock then update the item */

  rawStockVariantQuantity = isNaN(rawStockVariantQuantity) ? "10000" : rawStockVariantQuantity;
  rawStockVariantQuantity = parseInt(rawStockVariantQuantity);

  if (newQuantity < rawStockVariantQuantity) {
    $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);
    /* Update the item */

    CartJS.updateItem(lineItemCount, newQuantity, {}, {
      success: function success(data, textStatus, jqXHR) {//console.log(data);
        // //Rebind the line item price
        // reloadAjaxCartItemUsingCartAjaxObject(data);
      },
      error: function error(jqXHR, textStatus, errorThrown) {//console.log("Error: " + errorThrown + "!");
      },
      complete: function complete(jqXHR, textStatus, errorThrown) {//console.log(jqXHR);
        //console.log(textStatus);
        //console.log(errorThrown);
      }
    });
  } else {
    /* Show a message out of stock */
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").html("Out of stock");
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").show();
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").delay(2000).fadeOut();
  }
}

function minusQuantity(cartThis) {
  // debugger;
  var lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  var itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  var lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  var variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  newQuantity = newQuantity - 1;
  $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity); // CUSTOM - Loop through properties to check if there is a product with PromoOffer, if yes, then set the bool to true

  var properties = loopThroughCartItems_on_VariantID(variantID);

  if (properties != null) {
    if (Object.keys(properties).length > 0) {
      $.each(properties, function (key, value) {
        if (key == "_promoOffer") {
          boolPromoOffer_BlackFriday_ProductID = true;
        }
      });
    }
  }

  if (newQuantity < 1) {
    removeItem(lineItemCount);
  } else {
    CartJS.updateItem(lineItemCount, newQuantity, {}, {
      success: function success(data, textStatus, jqXHR) {},
      error: function error(jqXHR, textStatus, errorThrown) {//console.log("Error: " + errorThrown + "!");
      }
    });
    /*
    if you want to update item by ID and not by line item then you can use updateItemId function
    Recommended - line item update
    CartJS.updateItemById(lineIndex, newQuantity);
    */
  } // CUSTOM -
  //if the promo main product exists and it's quantity is less then 2, then remove the promo free bag product
  // if promo main product quantity  = 1; then remove the free bag and update the promo main product quantity
  // if promo main product quantity  = 0; then remove the promo main product
  // update the quantity for the promo main product


  if (boolPromoOffer_BlackFriday_ProductID && newQuantity <= 1) {
    if (newQuantity == 1) {
      //console.log("BLACK FRIDAY: Quantity 1");
      //loop through the cart items to get the variant ID for the PROMO - Free bag product
      //console.log("BLACK FRIDAY: going to delete free bag ");
      var _variantID = loopThroughCartItems_on_ProductID(promoOffer_BlackFriday_FreeBag_ProductID);

      removeItemById(_variantID);
    }
  }
}

function plusQuantity(cartThis) {
  var lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  var itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  var lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  var variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity); // Disable the PLUS quantity feature

  var proceedToUpdateQuantity = false;

  if (enablePlusQuantity) {
    if (newQuantity > disablePlusQuantityAfterNumber) {
      proceedToUpdateQuantity = true;
    }
  }

  if (proceedToUpdateQuantity == false) {
    newQuantity = newQuantity + 1;
    /* NOTE: you will not get Raw Inventory against the variant in API calls */

    /* PENDING, need to find a solution for this */

    /* Need to check stock levels for the variant 
    as cartJS is giving success even if the stock levels are low and not going into Error*/

    var rawStockVariantQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").attr("data-attr-raw-variant-quantity");
    /* If the new quantity is less then the stock then update the item */

    rawStockVariantQuantity = isNaN(rawStockVariantQuantity) ? "10000" : rawStockVariantQuantity;
    rawStockVariantQuantity = parseInt(rawStockVariantQuantity);

    if (newQuantity < rawStockVariantQuantity) {
      $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);
      /* Update the item */

      CartJS.updateItem(lineItemCount, newQuantity, {}, {
        success: function success(data, textStatus, jqXHR) {//console.log(data);
          // //Rebind the line item price
          // reloadAjaxCartItemUsingCartAjaxObject(data);
        },
        error: function error(jqXHR, textStatus, errorThrown) {//console.log("Error: " + errorThrown + "!");
        },
        complete: function complete(jqXHR, textStatus, errorThrown) {//console.log(jqXHR);
          //console.log(textStatus);
          //console.log(errorThrown);
        }
      });
    } else {
      /* Show a message out of stock */
      $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").html("Out of stock");
      $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").show();
      $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").delay(2000).fadeOut();
    }
  }
} //REMOVE ITEM via lineItemCount


function removeItem(lineItemCount) {
  CartJS.removeItem(lineItemCount, {
    success: function success(data, textStatus, jqXHR) {},
    error: function error(jqXHR, textStatus, errorThrown) {//console.log('Error: ' + errorThrown + '!');
    }
  });
} // REMOVE ITEM via variantID
//REMOVE ITEM


function removeItemById(variantID) {
  CartJS.removeItemById(variantID, {
    success: function success(data, textStatus, jqXHR) {},
    error: function error(jqXHR, textStatus, errorThrown) {//console.log('Error: ' + errorThrown + '!');
    }
  });
}

function reloadAjaxCartItemUsingCartAjaxObject(data) {
  //   cartInfo(data);
  $.ajax({
    type: "GET",
    url: "/cart?view=alternate.json",
    success: function success(response) {
      $(".cart-note").val(''); //extra information against the cart like collection title metafield, product title metafield, tags

      cartExtraInfo = $.parseJSON(response);
      cartInfo(data);
    },
    error: function error(status) {
      console.warn("ERROR", status);
      cartInfo(data);
    }
  });
} //RELOAD AJAX CART


function cartInfo(data) {
  var lineCount = 1;
  var cartObject;
  console.log(data);

  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
    quickCartTotal(data);
  }

  $(".js__ajax-products-bind").html("");
  $(".cart-list").html("");
  $(cartObject.items).each(function () {
    var imageURL = this.featured_image.url;
    var imageAlt = this.featured_image.alt;
    var itemPrice = this.original_price;
    var itemLinePriceTotal = this.line_price;
    var handle = this.handle;
    var itemID = this.id;
    var itemPriceAfterDiscount = this.discounted_price;
    var comparePrice = "";
    var disabled = "";
    var finalLineItemPrice = this.final_line_price;
    var cartBundleBoxID = "";
    var boolPromoOffer = false;
    $(cartExtraInfo.items).each(function (key, value) {
      if (value.id == itemID) {
        if (value.productImage != null) {
          imageURL = value.productImage;
        }

        console.log("productImage" + value.productImage);
      }
    });
    /*Bundle Free Bag Product*/

    if (this.properties != null) {
      itemProperties = this.properties;

      if (Object.keys(itemProperties).length > 0) {
        $.each(itemProperties, function (key, value) {
          /* If box ID exists, then remove quantity + -  working */
          if (key == boxID) {
            cartBundleBoxID = value;
          }

          if (key == "_promoOffer") {
            boolPromoOffer = true;
          }
        });
      }
    }
    /* get compare price using cartLib object */


    if (typeof cartLib !== "undefined") {
      $.each(cartLib, function (key, value) {
        //console.log(value);
        if (value["id"] == itemID) {
          comparePrice = value["comparePrice"];
        }
      });
    }
    /* FORMATTED PRICING */


    var formattedcomparePrice = comparePrice / 100;
    formattedcomparePrice = formatter.format(formattedcomparePrice); //console.log(imageURL);
    // check if the compared price is greater then item price then only show the compared price

    var comparePriceHtml = "";

    if (comparePrice > parseFloat(itemPrice)) {
      comparePriceHtml = "<s>" + formattedcomparePrice + "</s>";
    } // total compared price for the item with quantity


    var totalListItemComparePrice = comparePrice * this.quantity;
    totalListItemComparePrice = totalListItemComparePrice / 100;
    totalListItemComparePrice = formatter.format(totalListItemComparePrice); // item original price

    var formattedItemPrice = itemPrice / 100;
    formattedItemPrice = formatter.format(formattedItemPrice); // line price

    var formattedItemLinePriceTotal = itemLinePriceTotal / 100;
    formattedItemLinePriceTotal = formatter.format(formattedItemLinePriceTotal); //final line item price

    var formattedFinalLineItemPrice = finalLineItemPrice / 100;
    formattedFinalLineItemPrice = formatter.format(formattedFinalLineItemPrice); //console.log("formattedItemLinePriceTotal: " + formattedItemLinePriceTotal);
    //Price after discount

    var showPrice = "";
    var itemPriceAfterDiscountStatus = false;
    var discountedMessage = "";
    var discountedMessageElement = "";

    if (this.discounts != null) {
      discountedMessage = this.discounts;

      if (Object.keys(discountedMessage).length > 0) {
        //console.log("DISCOUNT EXISTS");
        discountedMessageElement = "<span class='discountedMessage hide'>";
        $.each(discountedMessage, function (key, value) {
          discountedMessageElement += value.title;
        });
        discountedMessageElement += "</span>";
      }
    }

    var formattedItemPriceAfterDiscount;
    formattedItemPriceAfterDiscount = itemPriceAfterDiscount / 100;
    formattedItemPriceAfterDiscount = formatter.format(formattedItemPriceAfterDiscount); // if itemPriceAfterDiscount > 0 then set the status to true so you can interchange the values

    if (this.discounts.length > 0) {
      itemPriceAfterDiscountStatus = true;
    } //console.log("itemPriceAfterDiscount STATUS: " + itemPriceAfterDiscountStatus)
    // if it's true; then show the compared price as the main price this.price and main price as discounted price


    if (itemPriceAfterDiscountStatus) {
      //comparePriceHtml
      showPrice = '<span class="price-wrapper js__raw-line-item-price"  data-attr-compare-price="0"><s>' + formattedItemPrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemPriceAfterDiscount + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>" + discountedMessageElement;
    } else {
      showPrice = '<span class="price-wrapper js__raw-line-item-price"  data-attr-compare-price="0">' + comparePriceHtml + '<span class="price" data-key="' + itemID + '">' + formattedItemPrice + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>";
    }

    var engravingMessageHtml = "";
    var boolEngravingMessage = false;
    var engravingMessage = "";
    var monogramMessageHtml = "";
    var boolMonogramMessage = false;
    var monogrammingMessage = "";
    /* Bind the properties */

    var itemProperties = "";
    var itemPropertiesElement = "";
    var itemPropertiesMainElement = "";
    var boolItemBoxType = false;
    var hideElementClass = "";
    var readonly = "";
    var justifyCenter = "";
    var formattedItemPriceMiniCart = formattedItemPrice;
    /* check if variantTitle is NULL, then don't show variant */

    var variantTitle = this.variant_title;

    if (variantTitle == null) {
      variantTitle = "";
    }

    var variantData = "";
    $.each(this.options_with_values, function (key, value) {
      console.log("key" + key);
      console.log("value" + value["name"]);
      console.log("value" + value["value"]);
      variantData += "<li><span>" + value["name"] + "</span><b>" + value["value"] + "</b></li>";

      if (value["name"].toLowerCase().indexOf("monogramming") > -1) {
        if (value["value"].toLowerCase() == "add a monogram") {
          boolMonogramMessage = true;
        }
      }

      if (value["name"].toLowerCase().indexOf("engraving") > -1 || value["name"].toLowerCase().indexOf("personalization") > -1) {
        if (value["value"].toLowerCase() != "no engraving") {
          boolEngravingMessage = true;
        }
      }
    });
    console.log("boolEngravingMessage" + boolEngravingMessage);
    /* Item properties */

    if (this.properties != null) {
      itemProperties = this.properties;
      console.log(itemProperties);

      if (Object.keys(itemProperties).length > 0) {
        itemPropertiesElement = "<ul>";
        $.each(itemProperties, function (key, value) {
          /*For store monogramming Message*/
          console.log("key" + key);

          if (key == "Monogram Message") {
            console.log("monogrammingMessage if");
            monogrammingMessage = value;
          }

          if (key == "Engraving Message") {
            console.log("EngravingMessage if");
            engravingMessage = value;
          }

          console.log("monogrammingMessage" + monogrammingMessage);
          /* If box ID exists, then remove quantity + -  working */

          if (key == boxID) {
            // CUSTOM: 2 below lines are used if you want to remove the quantity + -
            // hideElementClass = "hide";
            // readonly = "readonly='readonly'";
            boolItemBoxType = true;
            justifyCenter = "justify-center "; // CUSTOM: if you do not want to show the price and compared price in cart and mini cart then open the below variables
            // formattedItemPrice="-";
            // formattedcomparePrice="-";
            // formattedItemLinePriceTotal="-";
            // formattedItemPriceMiniCart="";
          }

          if (key.indexOf("_") > -1) {} else {
            if (key != boxID && key != "Monogram Message") {// itemPropertiesElement +=
              //     "<li class='flex'><span>" +
              //     key +
              //     ": </span><span style='padding-left: 5px'>" +
              //     value +
              //     "</span>";
              // itemPropertiesElement += "</li>";
            }
          } // Recharge - when subscription is via properties for older recharge version before November 2020


          recharge2020(key, value);
        }); // Recharge 2020, check if it's a subscription, then bind the value in the UL

        if (recurringchecked) {
          itemPropertiesElement += "<li class='flex'><span>Recurring Delivery every " + frequency + " " + frequency_unit + ". Change or cancel anytime</span>";
          itemPropertiesElement += "</li>";
        }

        itemPropertiesElement += "</ul>"; //console.log(itemPropertiesElement);

        itemPropertiesMainElement = itemPropertiesElement;
      } else {
        itemPropertiesElement = "";
      }
    }

    if (boolMonogramMessage == true) {
      monogramMessageHtml = '<input data-lineCount="' + lineCount + '" type="text" class="cart-textbox js__text-monogrammingMessage" value="' + monogrammingMessage + '" id="monogrammingMessag_' + itemID + '" />';

      if ($(".cart-note").val() == "") {
        $(".cart-note").val(this.product_title + " /" + this.variant_title + " : " + monogrammingMessage);
      } else {
        $(".cart-note").val($(".cart-note").val() + "\n" + this.product_title + " /" + this.variant_title + " : " + monogrammingMessage);
      }
    }

    console.log("boolEngravingMessage eeeeee" + boolEngravingMessage);

    if (boolEngravingMessage == true) {
      engravingMessageHtml = '<input data-lineCount="' + lineCount + '" type="text" class="cart-textbox js__text-engravingMessage" value="' + engravingMessage + '" id="engravingMessag_' + itemID + '" />';

      if ($(".cart-note").val() == "") {
        $(".cart-note").val(this.product_title + " /" + this.variant_title + " : " + engravingMessage);
      } else {
        $(".cart-note").val($(".cart-note").val() + "\n" + this.product_title + " /" + this.variant_title + " : " + engravingMessage);
      }
    }

    var sellingPlayInformation = "";

    if (this.selling_plan_allocation != undefined) {
      sellingPlayInformation = this.selling_plan_allocation.selling_plan.name;
    }
    /* CUSTOM - if the product title contains "bag",  then disabled the quantity element
    To be applied for all the products with BoxID and Promo Offer
    */
    // if (this.product_title.toLowerCase() == "bag") {


    try {
      if (this.product_title.toLowerCase().indexOf("bag") >= 0 && cartBundleBoxID != "" || this.product_title.toLowerCase().indexOf("bag") >= 0 && boolPromoOffer) {
        //if you want to hide the quantity + - then enable the class below
        // hideElementClass="hide"
        justifyCenter = "justify-center ";
        readonly = "readonly='readonly'";
        disabled = "disabled ";
      }
    } catch (_unused) {}
    /* 
    LINE ITEM FOR THE MINI CART
    */
    //elements
    // remove anchor


    var removeAnchorElement = '<div class="btn--secondary  remove js__cart-item-remove ' + removeExtraClass + '" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '"  data-cart-remove-variant="' + this.id + '" data-cart-line-count=' + lineCount + ">Remove</div>"; //quantity element

    var quantityElement = '<div class="cart-quantity-outer ' + disabled + justifyCenter + '"> <a  tabindex="0"  class="minus-qty ' + hideElementClass + '  font-zero" onclick="minusQuantity(' + lineCount + ')"   data-variant-id="' + itemID + '">' + minusIcon + '</a> <input aria-label="Quantity" readonly="readonly"  tabindex="-1"  data-limit="' + boolItemBoxType + '"  ' + readonly + '   onkeydown="return isNumeric(event);" type="text"  data-attr-raw-variant-quantity="94" data-cart-line-count="' + lineCount + '" class="cart__quantity-selector js__cart__quantity-selector" name="updates[]" id="updates_' + itemID + '" value="' + this.quantity + '" maxlength="3" size="3"> <a  tabindex="0"  class="plus-qty ' + hideElementClass + '  font-zero" onclick="plusQuantity(' + lineCount + ')"     data-variant-id="' + itemID + '">' + plusIcon + "</a> </div>"; //vendor element

    var vendorElement = '<span class="subheading uppercase">' + this.vendor + "</span>";
    var lineItem;
    lineItem = '<li class="flex-wrap js__cart-table-item-row" data-cart-line-count=' + lineCount + ' data-handle=' + handle + ' data-variant-id=' + itemID + ' key=' + this.key + '><div class="image-section"> <a class="image-wrapper" href="' + this.url + '"><img width="100" alt="' + imageAlt + '" src="' + imageURL + '""> </a> ' + removeAnchorElement + '</div>';
    lineItem += '<div class="content"><h5><a href="' + this.url + '">' + this.product_title + "</a></h5>";

    if (sellingPlayInformation != "") {
      lineItem += '<p class="capitalize">' + sellingPlayInformation + "</p>";
    }

    if (itemPropertiesElement != "") {
      lineItem += '<p class="capitalize">' + itemPropertiesElement + "</p>";
    }

    if (variantTitle != "") {
      lineItem += '<ul>' + variantData + "</ul>" + monogramMessageHtml + engravingMessageHtml;
    }

    lineItem += showPrice + '<div class="flex-space-between"><p class="hide">Qty ' + this.quantity + "</p>" + quantityElement; //lineItem += removeAnchorElement + "</div></div>";
    // !! NEED TO CHECK WITH DEV - why we using this variable here

    lineItem += "<span class='price'>" + formattedItemPriceAfterDiscount + "</span></div></div>";
    lineItem += "</li>";
    /* Bind the line item to the list */

    $(".js__ajax-products-bind").append(lineItem); //LINE ITEM FOR THE CART PAGE

    if ($(".cart-list")[0]) {
      //classLineItem = ".js__set-line-item-price";
      var cartLineItem = "";
      cartLineItem = '<div class="cart-list__items cart-table-body js__cart-table-item-row flex" data-cart-line-count="' + lineCount + '" data-attr-compare-price=""  key=' + this.key + ' data-variant-id="' + itemID + '"><div class="cart-list__items__columns"><div class="image-section "><img class="img-responsive img-thumbnail item-image" src="' + imageURL + '" alt="' + imageAlt + '" width="100"></div> <div class="content">'; // show vendor on cart page

      if (showVendorOnCartPage) {
        cartLineItem += vendorElement;
      }

      cartLineItem += '<a class="item-name" href="' + this.url + '"> <span class="item-title">' + this.product_title + " </span></a>";
      cartLineItem += '<div class="cart-list__variant-properties">';

      if (sellingPlayInformation != "") {
        cartLineItem += '<span class="capitalize">' + sellingPlayInformation + "</span>";
      }

      if (itemPropertiesElement != "") {
        cartLineItem += '<span class="capitalize">' + itemPropertiesElement + "</span>";
      }

      if (variantTitle != "") {
        cartLineItem += '<ul>' + variantData + "</ul>" + monogramMessageHtml + engravingMessageHtml;
      }

      cartLineItem += "</div>";
      cartLineItem += '<a class="remove btn--secondary small"  data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '" href="javascript:;">remove</a>  </div>  </div> ';
      cartLineItem += '<div class="cart-list__items__columns quantity" data-variant-id="' + itemID + '"> ' + quantityElement + '  <span class="js__out-of-stock"></span>'; // ** Remove action is added here too

      cartLineItem += '</div>';
      cartLineItem += '<div class="cart-list__items__columns">';
      cartLineItem += showPrice;
      cartLineItem += "</div>";
      /*cartLineItem += '<div class="cart-list__items__columns total-price hide price-wrapper" data-head="Total"> <span class="js__set-line-item-price" data-attr-price="' +
      itemPrice +
      '" data-attr-compare-price=' +
      totalListItemComparePrice +
      '><s class="hide">' +
      totalListItemComparePrice +
      '</s><span class="price" data-key="' +
      itemID +
      '">' +
      formattedItemLinePriceTotal +
      "</span> </span></div";*/
      // ** Remove element is added here too
      //cartLineItem +="<a class=' remove btn-border-small-black ipad-block ' data-cart-line-count='" +lineCount +"' data-variant-id='" +itemID +"' href='javascript:;'>remove</a> ";

      cartCountEmptyValue += "</div>";
      $(".cart-list").append(cartLineItem);
    }

    lineCount++;
  });
} //CALCULATE TOTAL OF THE CART


function quickCartTotal(data) {
  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
  }

  var total = cartObject.items_subtotal_price;
  total = total / 100;
  total = formatter.format(total);
  $(".js__cart-total").html(total);
  $(".js__ajax-cart-total").html("" + total);
  $(".js__ajax-cart-total").show();
  $(".js__ajax-cart-count").html(cartObject.item_count);
  $(".js__top-cart-form-actions").show();

  if (cartObject.item_count == 0) {
    $(".js__ajax-cart-count.cart-count").hide();
    $(".js__cart-expand ").removeClass("fill");
  } else {
    $(".js__cart-expand ").addClass("fill");
  }

  $(".js__cart-expand ").removeClass("empty-cart");
}

function calculateSubTotalWithDiscount() {
  var subTotal = 0;
  var discount = 0;
  var total = 0;
  var lineItemComparePrice = 0;
  var itemPrice = 0;
  var quantity = 0; // ! PENDING - Here the quantity is static which comes from the page load only - voa cart Lib,
  // ! need to update this function to get the quantity of the line item

  /*
  1. loop through the cart items
  2. just to get the compared price - loop through the cartLib
  3. match the variant id with the cartLib ID
  4. If it matches, then get the compared price
  */

  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    return res.json();
  }).then(function (data) {
    $.each(data.items, function (key, value) {
      var variantID = value.id;
      var quantity = value.quantity;
      $.each(cartLib, function (key, cartLibvalue) {
        if (variantID == cartLibvalue.id) {
          if (cartLibvalue.comparePrice != "") {
            lineItemComparePrice = parseInt(cartLibvalue.comparePrice) * quantity;
          } else {
            lineItemComparePrice = parseInt(value.final_line_price);
          }
        }
      });
      itemPrice = parseInt(value.price) * quantity; //console.log("itemPrice: " + itemPrice);

      subTotal += lineItemComparePrice;
      console.log("subTotal: " + subTotal);
      discount += lineItemComparePrice - itemPrice; //console.log("discount: " + discount);
    });
    total = data.total_price; //format

    if (discount == 0) {
      console.log("discountdiscount" + discount);
      $(".js__cartDiscountWraper").hide();
    } else {
      $(".js__cartDiscountWraper").show();
    }

    subTotal = subTotal / 100;
    subTotal = formatter.format(subTotal);
    discount = discount / 100;
    discount = formatter.format(discount);
    total = total / 100;
    total = formatter.format(total);
    console.log("data.item_count" + data.item_count);

    if (data.item_count > 0) {
      $(".js__cart-sub-total").html(subTotal);
      $(".js__cart-total-saved").html("-" + discount);
      $(".js__cart-total").html(total);

      if (showCartCountInTopNav) {
        $(".js__ajax-cart-count").show();
        $(".js__ajax-cart-count").html(data.item_count);
      }

      $(".free-shipping").show(); //show/hide js__cartSubtotalDiscountWraper - if you want to show subtotal and discount

      showCartSubTotalDiscountSection ? $(".js__cartSubtotalDiscountWraper").removeClass("hide") : console.log("SubTotal Discount Wrapper: NOT visible");
    } else {
      /* 
      update cart item count = 0
      hide the totals
      hide checkout buttons
      update the icon cart with a different icon
      */
      $(".js__ajax-products-bind").html('<li class="empty-mini-cart"><div class="width-100"> <p class="">No items</p> </div></li>');
      $(".freq-product-list").hide();
      $(".free-shipping").hide();
      $(".js__ajax-cart-count").html(cartCountEmptyValue);
      $(".js__ajax-cart-total").hide();
      $(".js__top-cart-form-actions").hide();
      $(".js__show-cart-items-section").hide();
      $(".empty-cart-section").show();
      $(".js__cart-expand ").addClass("empty-cart"); //change the icon for the top cart, if required

      showEmptyCartIcon ? $(".js__update-cart-icon").addClass("empty-cart") : console.log("Top Cart Icon: NOTchanged");
    }
  });
  /* loop through eachcart item and get the compared price and actual price */
  // if (typeof cartLib !== "undefined") {
  //   $.each(cartLib, function (key, value) {
  //     quantity = parseInt(value.quantity);
  //     console.log("quantity: " + quantity);
  //     if (value.comparePrice != "") {
  //       lineItemComparePrice =
  //         parseInt(value.comparePrice) * quantity + lineItemComparePrice;
  //     } else {
  //       console.log("compare price not in cartlib");
  //       lineItemComparePrice = parseInt(value.price) * quantity;
  //     }
  //     console.log("lineItemComparePrice: " + lineItemComparePrice);
  //     itemPrice = parseInt(value.price) * quantity;
  //     //console.log("itemPrice: " + itemPrice);
  //     subTotal += lineItemComparePrice;
  //     console.log("subTotal: " + subTotal);
  //     discount += lineItemComparePrice - itemPrice;
  //     //console.log("discount: " + discount);
  //   });
  //   total = CartJS.cart.total_price;
  //   //format
  //   subTotal = subTotal / 100;
  //   subTotal = formatter.format(subTotal);
  //   discount = discount / 100;
  //   discount = formatter.format(discount);
  //   total = total / 100;
  //   total = formatter.format(total);
  // }
  // if (CartJS.cart.item_count > 0) {
  //   $(".js__cart-sub-total").html(subTotal);
  //   $(".js__cart-total-saved").html("-" + discount);
  //   $(".js__cart-total").html(total);
  //   if (showCartCountInTopNav) {
  //     $(".js__ajax-cart-count").show();
  //     $(".js__ajax-cart-count").html(CartJS.cart.item_count);
  //   }
  //   $(".free-shipping").show();
  //   //show/hide js__cartSubtotalDiscountWraper - if you want to show subtotal and discount
  //   showCartSubTotalDiscountSection
  //     ? $(".js__cartSubtotalDiscountWraper").removeClass("hide")
  //     : console.log("SubTotal Discount Wrapper: NOT visible");
  // } else {
  //   /* 
  //   update cart item count = 0
  //   hide the totals
  //   hide checkout buttons
  //   update the icon cart with a different icon
  //   */
  //   $(".js__ajax-products-bind").html(
  //     '<li class="empty-mini-cart"><div class="width-100"> <p class="">Your cart is empty</p> </div></li>'
  //   );
  //   $(".freq-product-list").hide();
  //   $(".free-shipping").hide();
  //   $(".js__ajax-cart-count").html(cartCountEmptyValue);
  //   $(".js__ajax-cart-total").hide();
  //   $(".js__top-cart-form-actions").hide();
  //   $(".js__show-cart-items-section").hide();
  //   $(".empty-cart-section").show();
  //   $(".js__cart-expand ").addClass("empty-cart");
  //   //change the icon for the top cart, if required
  //   showEmptyCartIcon
  //     ? $(".js__update-cart-icon").addClass("empty-cart")
  //     :
  //     console.log("Top Cart Icon: NOTchanged");
  // }
}
/*
  CUSTOM-- for the BUILDER
  THIS FUNCTION IS USED WHEN THERE IS NO QUANTITY BOX VISIBLE AGAINST THE ITEM
  //Variest from theme to theme
   1. Loop through cart items
   2. If item has property > 0 
   3. Then check for boxID 
   4. Save the BoxID in a variable
   5. Then go through the second cart item
   6. if currentItemPropertyBoxID = savedItemPropertyBoxID
   7. Then remove the item
   8. Else do not do anything
*/


var savedItemPropertyBoxID = "";
var currentItemPropertyBoxID = "";
var clickedRemoveItemStatus = false;
var currentItemID = "";
$(document).on("click", ".remove", function () {
  //console.log("REMOVE CLICKED");
  var howManyItemsToDelete = 0;
  var howManyVariantIDToDelete = [];
  var variantID = parseInt($(this).attr("data-variant-id"));
  var itemLineCount = parseInt($(this).attr("data-cart-line-count")); //console.log("itemLineCount: " + itemLineCount);

  var extraItemLineCount = 1;
  /* offer main product ID and bool*/

  var productID = ""; //Run properties loop and set clickRemove status = true if BoxID is found

  $(CartJS.cart.items).each(function () {
    if (itemLineCount == extraItemLineCount) {
      //console.log("clicked - variantID : " + variantID);
      productID = this.product_id;
      $.each(this.properties, function (key, value) {
        //console.log("key: " + key);
        if (key == boxID) {
          //console.log("key2: " + key);
          savedItemPropertyBoxID = value;
          clickedRemoveItemStatus = true;
        }
        /* CUSTOM: Checking deleted item is main product of promo offer*/


        if (key == "_promoOffer") {
          if (productID == promoOffer_BlackFriday_ProductID) {
            boolPromoOffer_BlackFriday_ProductID = true;
          }
        }
      });
    }

    extraItemLineCount = extraItemLineCount + 1; //console.log("clickedRemoveItemStatus: " + clickedRemoveItemStatus);

    if (clickedRemoveItemStatus) {
      //console.log("clickedRemoveItemStatus: " + true);
      clickedRemoveItemStatus = false;
      return false;
    }
  });
  extraItemLineCount = 1;
  /* CUSTOM: Loop through items and properties */

  $(CartJS.cart.items).each(function () {
    currentItemID = this.id; //console.log("LoopCurrentItemID: " + currentItemID);

    $.each(this.properties, function (key, value) {
      //console.log("key4: " + key);
      //console.log("boxID4: " + boxID);
      if (key == boxID) {
        //console.log("Property Match");
        currentItemPropertyBoxID = value; //console.log("currentItemPropertyBoxID: " + currentItemPropertyBoxID);
        //console.log("savedItemPropertyBoxID: " + savedItemPropertyBoxID);

        if (currentItemPropertyBoxID == savedItemPropertyBoxID) {
          //console.log("remove the current item");
          extraItemLineCount = 1;
          howManyItemsToDelete = howManyItemsToDelete + 1;
          howManyVariantIDToDelete.push(currentItemID); //Remove the product that clicked
        } else {
          extraItemLineCount = extraItemLineCount + 1;
        }
      } else {//console.log("BOX ID ISN'T THERE IN PRODUCT");
        //removeItem(itemLineCount);
      }
    }); //console.log("howManyVariantIDToDelete: " + howManyVariantIDToDelete);
  }); //console.log("TOTAL: howManyVariantIDToDelete: " + howManyVariantIDToDelete);
  //console.log("TOTAL howManyItemsToDelete: " + howManyItemsToDelete);

  if (howManyItemsToDelete == 0) {
    //console.log("ITEM TO DELETE: " + 0);
    removeItem(itemLineCount);
  } else {
    //console.log("TOTAL # of item to delete > 0");

    /* 
    Remove the items depending upon how many are to be deleted
    Run the loop again and delete them one by one 
    */
    //console.log(howManyVariantIDToDelete.length);
    var currentItemLoop = 1; // NOTE: used "removeItemById" as for this particular project ..

    for (var n = 0; n < howManyVariantIDToDelete.length; ++n) {
      removeItemById(howManyVariantIDToDelete[n]); //debugger;
      // $(CartJS.cart.items).each(function () {
      //   //console.log("howManyVariantIDToDelete");
      //   //console.log(howManyVariantIDToDelete[n]);
      //   //console.log(this.title);
      //   //console.log(this.properties);
      //   //debugger;
      //   if (jQuery.isEmptyObject(this.properties)) {
      //     //console.log("Property is empty");
      //     currentItemLoop = currentItemLoop + 1;
      //   } else {
      //     $.each(this.properties, function (key, value) {
      //       if (key == boxID ) {
      //         //console.log("FINAL - BOX ID FOUND 1 by 1");
      //         currentItemPropertyBoxID = value;
      //         if (currentItemPropertyBoxID == savedItemPropertyBoxID) {
      //           //console.log("remove the final loop item");
      //           removeItemById(howManyVariantIDToDelete[n]);
      //           currentItemLoop = 1;
      //           //Remove the product that clicked
      //         } else {
      //           currentItemLoop = currentItemLoop + 1;
      //         }
      //       }
      //       else
      //       {
      //         //console.log("FINAL - BOX ID NOT FOUND 1 by 1");
      //       }
      //     });
      //     if (currentItemLoop == 1) {
      //       return false;
      //     }
      //   }
      // });
    }
  }

  showHideEmptyCart();
});

function showHideEmptyCart() {
  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
}
/*
PROGRESS BAR
*/


function progressBar() {
  if (showProgressBar) {
    var totalAmount = CartJS.cart.total_price / 100;
    var freeShippingAmount = parseFloat($(".js__free-shipping-limit").html());
    var freeShippingRemaningAmount = freeShippingAmount - totalAmount;
    var freeShippingPercentage = 100;

    if (freeShippingRemaningAmount > 0) {
      freeShippingPercentage = totalAmount * 100 / freeShippingAmount;
      $(".js__free-shipping-limit-message").show();
      $(".js__free-shipping-message").hide();
    } else {
      $(".js__free-shipping-limit-message").hide();
      $(".js__free-shipping-message").show();
    }

    $(".js__free-shipping-remaning-amount").html(formatter.format(freeShippingRemaningAmount));
    $(".js__free-shipping__progress-bar").attr("data-percentage", freeShippingPercentage);
    $(".js__free-shipping__progress-bar").children("span").css("width", freeShippingPercentage + "%");
  }
}

function getCartData() {
  $.getJSON("/cart.js", function (cart) {
    cartInfo(cart);
    progressBar();
    setTimeout(function () {
      addons();
    }, 1000);
  });
}
/*
ADDONS
NOTE:: CONFUSING CODE FOR THE ADDONS - WILL NEED TO CLEAN IT A BIT
1. Try to get all the addon handles for the items which are in the cart
2. Create an array for item>addon
3. Loop through all the cart items and addon
4. CHECK - if addon is already there in the list, then the same 2nd addon should not be visible
*/


$(document).ready(function ($) {
  $(".js__addon-add-to-cart").click(function () {
    var quantity = 1;
    var addonSelectedVariantID = $(this).attr("data-attr-variantid");
    cartAddItemAddon(addonSelectedVariantID, quantity);
  });
  $(".js__addon-add-to-cart").keypress(function () {
    var keycode = event.keyCode || event.which;

    if (keycode == "13") {
      event.preventDefault();
      var quantity = 1;
      var addonSelectedVariantID = $(this).attr("data-attr-variantid");
      cartAddItemAddon(addonSelectedVariantID, quantity);
    }
  });
});

function cartAddItemAddon(addonSelectedVariantID, addonQuantity) {
  CartJS.addItem(addonSelectedVariantID, addonQuantity, {}, {
    success: function success(data, textStatus, jqXHR) {//console.log("success");

      /* Pending - Remove the selected addon when add to cart is clicked */
    },
    error: function error(jqXHR, textStatus, errorThrown) {//console.log("error");
    }
  });
}

function addons() {
  //console.log("addons");

  /*Hide repeating addons*/
  var cartAddons = "";
  $(".js__top-cart-addons li").each(function (index) {
    // update this with variantID
    var addoneHandle = $(this).attr("data-handler"); // if cartAddon is null,

    if (cartAddons == "") {
      // save the addonHandle
      cartAddons = addoneHandle;
    } else {
      //set bool value to see if the addons is present in the addon list or not
      // by default it's false
      var boolCartAddons = false; // going through the string and checking if the current addon handle = the addon
      //handle present in the string

      var cartAddons2 = cartAddons.split(",");

      for (var a = 0; a < cartAddons2.length; a++) {
        if ($(this).attr("data-handler") == cartAddons2[a]) {
          // if present, then hide it
          $(this).hide();
          boolCartAddons = true;
        }
      } // add the new addon handle to the string


      if (boolCartAddons == false) {
        cartAddons = cartAddons + "," + addoneHandle;
      }
    } //console.log(cartAddons);

    /* Hide the addons from the addon list, if the addon is present in the cart */


    var boolItemCartAddon = false;
    $(".js__ajax-products-bind li").each(function (index) {
      var itemHandle = $(this).attr("data-handle"); //console.log("itemHandle"+itemHandle);
      //console.log("addoneHandle"+addoneHandle)

      if (addoneHandle == itemHandle) {
        boolItemCartAddon = true;
      }
    });

    if (boolItemCartAddon == true) {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
  /* Hide the complete section if there are no addons */

  var boolAddonExist = false;
  $(".js__top-cart-addons li").each(function (index) {
    if ($(this).css("display") != "none") {
      boolAddonExist = true;
    }
  }); //console.log("boolAddonExist"+boolAddonExist);

  if (boolAddonExist == false) {
    //console.log("if");
    $(".js__freq-bought-products").hide();
  } else {
    //console.log("else");
    $(".js__freq-bought-products").show();
  }
} //Addons are fetched from the schemas; Varies from theme to theme


setTimeout(function () {
  addons();
}, 1000); //loop through cart items to get property on the basis of variant ID

function loopThroughCartItems_on_VariantID(variantID) {
  var currentVariantID = "";
  var properties = "";
  $(CartJS.cart.items).each(function () {
    // currentVariantID = this.id;
    if (variantID == this.id) {
      properties = this.properties;
      return false;
    }
  });
  return properties;
}

function loopThroughCartItems_on_ProductID(productID) {
  var variantID = "";
  $(CartJS.cart.items).each(function () {
    // currentVariantID = this.id;
    if (productID == this.product_id) {
      variantID = this.id;
      return false;
    }
  });
  return variantID;
}

function recharge2020(key, value) {
  if (key == "shipping_interval_frequency") {
    frequency = value;
    recurringchecked = "true";
  }

  if (key == "shipping_interval_unit_type") {
    if (frequency == "1") {
      if (value == "Days") {
        frequency_unit = "Day";
      } else if (value == "Months") {
        frequency_unit = "Month";
      } else if (value == "Weeks") {
        frequency_unit = "Week";
      }
    } else {
      frequency_unit = value;
    }
  }
}
"use strict";

jQuery(function () {
  /** Fix Header on Scroll **/
  $(window).scroll(function () {
    var sticky = $(".js__secondary-nav"),
        scroll = $(window).scrollTop();

    if (scroll >= 35) {
      var id = sticky.parent("div").attr("id");
      console.log("id" + id);

      try {
        if (id == undefined) {
          sticky.addClass("fixed");
        } else {
          if (id.indexOf("__innerBanner") > -1 || id.indexOf("__collectionHeader") > -1) {
            sticky.parent('div').addClass("inner-hero-section");
            sticky.parent('div').addClass("fixed");
          } else {
            sticky.addClass("fixed");
          }
        }

        $(".main-content").addClass("active");

        if ($(".js__secondary-nav").html() != undefined) {
          $("#shopify-section-header").addClass("no-fixed");
        }
      } catch (_unused) {}
    } else {
      sticky.parent('div').removeClass("inner-hero-section");
      sticky.parent('div').removeClass("fixed");
      sticky.removeClass("fixed");
      $(".main-content").removeClass("active");
      $("#shopify-section-header").removeClass("no-fixed");
    }

    if (scroll >= 115) {
      $(".collection__filter-section-outer").hide();
    } else {
      $(".collection__filter-section-outer").show();
    }
  });
  $(window).scroll(function () {
    var sticky = $(".js__secondary-pdp-nav"),
        scroll = $(window).scrollTop();

    if (scroll >= 35) {
      sticky.addClass("fixed");
      $("body").addClass("navigation-fixed");
      $(".main-content").addClass("active");

      if ($(".js__secondary-nav").html() != undefined) {// $(".js__main-header").addClass("no-fixed");
      }
    } else {
      $("body").removeClass("navigation-fixed");
      sticky.removeClass("fixed");
      $(".main-content").removeClass("active"); // $(".js__main-header").removeClass("no-fixed");
    }
  });
  var realtedPost = new Swiper(".js__realted-post-slider", {
    slidesPerView: "3",
    spaceBetween: 21,
    centeredSlides: false,
    breakpoints: {
      0: {
        slidesPerView: "2",
        spaceBetween: 11
      },
      601: {
        spaceBetween: 21,
        slidesPerView: "3"
      },
      769: {
        spaceBetween: 21,
        slidesPerView: "3"
      }
    }
  });
  var threeColumnArticleSlider = new Swiper(".js__three-column-article-slider", {
    slidesPerView: "3",
    spaceBetween: 21,
    centeredSlides: false,
    breakpoints: {
      0: {
        slidesPerView: "2",
        spaceBetween: 11
      },
      769: {
        spaceBetween: 21,
        slidesPerView: "3"
      }
    }
  });
  var fourColumnImageSlider = new Swiper(".js__four-column-image-slider", {
    slidesPerView: "auto",
    spaceBetween: 10,
    grabCursor: true,
    mousewheelControl: true,
    keyboardControl: true
  });
  /*Checking tabcontent*/

  $(".js__tab-content").each(function () {
    if ($(this).find(".js__accordian").html().trim() == "") {
      $(this).find(".js__accordian").html('<li>Sorry No Data</li>');
    }
  });
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path

  $(".js__blog-category li").each(function () {
    var liPath = $(this).children("a").attr("href").toLowerCase();
    console.log(liPath);
    console.log(path.toLowerCase());

    if (liPath === path.toLowerCase()) {
      $(this).children("a").addClass("active");
    }
  });
  $(".dropdown-select option").each(function () {
    if (this.value.toLowerCase() == path.toLowerCase()) {
      this.setAttribute("selected", true);
    }
  });
  $(".dropdown-select").change(function () {
    var dropdown = $(".dropdown-select").val(); //first hide all tabs again when a new option is selected

    $(".tab-content").hide(); //then show the tab content of whatever option value was selected

    $("#" + "tab-" + dropdown).show();
  });

  try {
    var pageTotal = parseInt($(".js__total-page").val());
    var currentPage = parseInt($(".js__current-page").val());
    var itemTotal = parseInt($(".js__items-count").val());
    var perPageItem = parseInt($(".js__perpage-item").val());
    var itemStart = 1;
    var itemEnd = 0;

    if (currentPage > 1) {
      itemStart = perPageItem * (currentPage - 1) + 1;
    }

    itemEnd = itemStart + perPageItem - 1;

    if (pageTotal == currentPage) {
      itemEnd = itemTotal;
    }

    $(".js__page-range").html(itemStart + " - " + itemEnd);
  } catch (_unused2) {}
  /* PDP
   $(".drop-down-outer select option").each(function () {
        if (this.value.toLowerCase() == path.toLowerCase()) {
          this.setAttribute("selected", true);
        }
      });
  
      /*Insta Images click*/

  /*Tab working */


  $(".js__insta-images li").on("click", function () {
    // $(this).toggleClass("active");
    if (!$(this).hasClass('active')) {
      $(".js__insta-images li").removeClass("active");
      $(this).toggleClass("active");
    } else {
      $(this).removeClass("active");
    }
  });
  $(".js__four-column-image-slider a").on("click", function () {
    $(this).children("span").show();
  });
  $(".js__dropdown li .tab-link-all").on("click", function (event) {
    event.preventDefault();

    if ($(".tab-link-all").hasClass("active")) {
      $(".tab-link-all").removeClass("active");
    } else {
      $(".tab-link-all").removeClass("active");
      $(this).addClass("active");
    }

    $(".tab-link").removeClass("active");
    $(".js__tab-content").each(function () {
      if ($(this).find(".js__accordian").html().trim() == "<li>Sorry Data Is Not Added Yet</li>") {
        $(this).hide();
        $(this).removeClass("tab-content-all");
      } else {
        $(this).show();
        $(this).addClass("tab-content-all");
      }
    });
  });
  $(".tab-link").on("click", function () {
    $(".tab-link-all").removeClass("active");
    var dataId = $(this).attr("data-attr");
    $(".js__tab-content").removeClass("tab-content-all");
    var i, tabcontent, tablink, tabcont;
    tabcontent = document.getElementsByClassName("tab-content");

    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    tablink = document.getElementsByClassName("tab-link");

    for (i = 0; i < tablink.length; i++) {
      tablink[i].className = tablink[i].className.replace(" active", "");
    }

    document.getElementById(dataId).style.display = "block";
    event.currentTarget.className += " active";
    /*PDP select*/

    $(".js__pdp-tab-select").val(dataId);
  });
  $('.filter-btn').on("click", function () {
    try {
      var dataId = $(this).attr("href");
      var i, tabcontent, tablink;
      tabcontent = document.getElementsByClassName("option");

      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }

      tablink = document.getElementsByClassName("filter-btn");

      for (i = 0; i < tablink.length; i++) {
        tablink[i].className = tablink[i].className.replace(" active", "");
      }

      document.getElementById(dataId).style.display = "block";
      event.currentTarget.className += " active";
    } catch (_unused3) {}
  });
  $('.filter-btn-mobile').on("click", function () {
    var dataId = $(this).attr("data-attr");
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("optionMobile");

    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    tablink = document.getElementsByClassName("filter-btn-mobile");

    for (i = 0; i < tablink.length; i++) {
      tablink[i].className = tablink[i].className.replace(" active", "");
    }

    document.getElementById(dataId).style.display = "block";
    event.currentTarget.className += " active";
  });
  /* GLOBAL
  Scroll to particular Div with # value */

  $('a[href^="#"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));

    if (target.length) {
      event.preventDefault();
      $(".tab-head").hide();
      $("html, body").stop().animate({
        scrollTop: target.offset().top - 150
      }, 1000);
    }
  }); // $(".js__accordian").children("li:first-child").addClass("active");

  /* accordion working about content in small screen*/

  $(".js__accordian").children("li").children("h5,h6,h3").click(function (e) {
    if ($(this).parent("li").children(".content").css("display") == "none") {
      $(this).parent("li").parent(".js__accordian").children("li").children(".content").hide();
      $(this).parent("li").parent(".js__accordian").children("li").removeClass("active");
      $(this).parent("li").children(".content").slideDown();
      $(this).parent("li").addClass("active");
      /* $('html,body').animate({
        scrollTop: $(this).offset().top - 120
      }, 500);*/
    } else {
      $(this).parent("li").children(".content").slideUp();
      $(this).parent("li").removeClass("active");
    }
  }); // comment js 

  $(".js__commentbutton").children(".add_comment").children(".btn").click(function (e) {
    if ($(this).parent(".add_comment").children(".comment_form").css("display") == "none") {
      $(this).parent(".add_comment").parent(".js__accordian").children(".add_comment").children(".comment_form").hide();
      $(this).parent(".add_comment").parent(".js__accordian").children(".add_comment").removeClass("active");
      $(this).parent(".add_comment").children(".comment_form").slideDown();
      $(this).parent(".add_comment").addClass("active");
      /* $('html,body').animate({
        scrollTop: $(this).offset().top - 120
      }, 500);*/
    } else {
      $(this).parent(".add_comment").children(".comment_form").slideUp();
      $(this).parent(".add_comment").removeClass("active");
    }
  });
});
/** Dropdown **/

jQuery(function ($) {
  $(document).on("mouseover", ".js__custom-dropdown", function () {
    $(this).addClass("active");
  });
  $(document).on("mouseleave", ".js__custom-dropdown", function () {
    $(this).removeClass("active");
  });
  var collectionColor = "";
  $(".js__custom-dropdown li").on("click", function () {
    console.log("clickkkk");
    var color = $(this).children("a").attr("data-color");
    collectionColor = color;
    $(".js__custom-dropdown li").children("a").removeClass("active");

    if (color == "" || color == "All colors") {
      $(".js__selected-color .close").click();
      $(".js__selected-color").removeClass("active");
    } else {
      $(".js__selected-color").addClass("active");
      $(".js__selected-color").children("span").html(color);
      $(this).children("a").addClass("active");
      colorSwatchFilter();
    }
  });
  /*Setting color filter Images */

  $(".js__custom-dropdown li").each(function () {
    var color = $(this).find("span").html();
    var colorImage = getColorImage(color);
    $(this).find(".icon").addClass("no-image");

    if (colorImage != "") {
      $(this).find("img").attr("src", colorImage);
      $(this).find(".icon").removeClass("no-image");
    }
  });

  function getColorImage(color) {
    try {
      var variantColorImage = "";
      $.each(prodColor, function (key, value) {
        if (color.toLowerCase() == value.title.toLowerCase()) {
          variantColorImage = value.color;
        }
      });
      return variantColorImage;
    } catch (_unused4) {}
  }

  function colorSwatchFilter() {
    $(".collection__product-list li").each(function () {
      try {
        var tags = $(this).attr("data-tags").split(",");

        for (var k = 0; k < tags.length; k++) {
          if (tags[k].toLowerCase() == collectionColor.toLowerCase()) {
            var images = $(this).attr("data-images").split(",");

            for (var l = 0; l < images.length; l++) {
              var imageUrl = images[l].split("~")[0];
              var imageAlt = images[l].split("~")[1];

              if (imageAlt.toLowerCase() == tags[k].toLowerCase()) {
                $(this).children(".image-section").find(".js__product-featured-image").attr("src", imageUrl);
              }
            }
          }
        }
      } catch (_unused5) {}
    });
  }
  /*Function for load more and default color swatch*/


  setInterval(function () {
    if (collectionColor != "" && collectionColor != "All colors") {
      localStorage.setItem("selected-color-swatch", collectionColor.toLocaleLowerCase());
      colorSwatchFilter();
    } else {
      $(".all-color-li").find("a").addClass("active");
    }
  }, 100);
  $(".js__custom-dropdown li.active").click();
  /*Function for load more and default color swatch*/

  /*Color  option removed*/

  $(".js__selected-color .close").on("click", function () {
    /* collectionColor = "";
     $(".js__selected-color").removeClass("active");
     $(".js__custom-dropdown li").children("a").removeClass("active");
     $(".collection__product-list li").show();
     $(".collection__product-list li").each(function() {
         try {
             var imageUrl = $(this).children(".image-section").find(".js__product-featured-image").attr("data-src")
               $(this).children(".image-section").find(".js__product-featured-image").attr("src", imageUrl);
           } catch {
           }
       })*/
    window.location.href = $(".js__collection-url").html();
  });
  /*Color dropdown selected*/

  $(".js__dropdown_result").on("click", function () {
    $(".dropdown").toggleClass("active");

    if ($(".js__dropdown").css("display") == "none") {
      $(".js__dropdown").slideDown(300);
      $(".js__dropdown li a").on("click", function () {
        $(".js__dropdown").css("display", "none");
        $(".js__dropdown_result").removeClass("active");
        $(".dropdown").removeClass("active");
      });
    } else {
      $(".js__dropdown").slideUp(300);
    }

    $(this).toggleClass("active");
  });
  $(".js__location_result").on("click", function () {
    if ($(".js__location").css("display") == "none") {
      $(".js__location").slideDown(300);
    } else {
      $(".js__location").slideUp(300);
    }

    $(this).toggleClass("active");
  });
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path

  $(".js__dropdown li a").each(function () {
    if (this.href === path) {
      $(this).addClass("active");
      console.log($(this).html());
      /*if ($(this).html() != "view all") {
          $(".js__dropdown_result").html($(this).html());
        }*/

      $(".js__dropdown").slideUp(300);
      $(".js__dropdown_result").removeClass("active");
    }
  });
  $(".menu-list li a").each(function () {
    var pathLast = path.split('/');
    var pathLastName = pathLast[pathLast.length - 1];
    var urlLast = $(this).attr("href").split('/');
    var menuTitle = $(this).html().toLowerCase().trim();
    var urlLastName = urlLast[urlLast.length - 1];
    console.log(pathLastName);
    console.log(pathLastName);

    if (urlLastName == pathLastName) {
      if ($(this).html() != "view all") {
        $(this).addClass("active");
      }
    } else {
      console.log("else");
      console.log("menuTitle" + menuTitle + "sfsdf");
      console.log("urlLastName" + urlLastName.toLowerCase() + "sfsdf");

      if (pathLastName.toLowerCase() == menuTitle) {
        console.log("iffffff");

        if ($(this).html() != "view all") {
          $(this).addClass("active");
        }
      }
    }
  });

  if (window.location.href.indexOf("article&") > -1) {
    $(".js__search-type").html("Show Product Results");
    $(".search-item").val("article");
    $(".js__search-title").html("Blog Posts");
  } else {
    $(".js__search-type").html("Show Blog Results");
    $(".search-item").val("product");
    $(".js__search-title").html("Products");
  }

  $(".js__search-type").on("click", function () {
    console.log($(this).html());

    if ($(this).html().trim() == "Show Blog Results") {
      $(".search-item").val("article");
      $(this).html("Show Product Results");
      $(".js__search-title").html("Blog Posts");
      $(".js__search-submit").click();
    } else {
      $(".search-item").val("product");
      $(this).html("Show Blog Results");
      $(".js__search-title").html("Products");
      $(".js__search-submit").click();
    }
  });
});
/* Mini cart - Checkout Button visiblity fix for IOS Mobile */

var lastScroll = 0;
jQuery(document).ready(function ($) {
  $(".cart-sidebar__middle").addClass("safari-mobile");
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll > lastScroll) {
      $(".cart-sidebar__middle").removeClass("safari-mobile");
    } else if (scroll < lastScroll) {
      $(".cart-sidebar__middle").addClass("safari-mobile");
    }

    lastScroll = scroll;
  });
});
/** Dropdown **/

jQuery(function ($) {
  /*Blog dropdown*/
  $(".js__blog-select").change(function () {
    window.location = $(this).val();
  });
  /*Dropdown selected*/

  $(".js__blog-select option").each(function (index) {
    var value = $(this).val().toLowerCase();

    if (window.location.href.toLowerCase().indexOf(value) > -1) {
      $(".js__blog-select").val($(this).val());
    }
  });
  $('input[type="checkbox"]').click(function () {
    if ($(this).is(":checked")) {
      //input element where you put value
      $(this).parent("label").addClass("active");
    } else if ($(this).is(":not(:checked)")) {
      $(this).parent("label").removeClass("active");
    }
  }); // header fixed

  try {
    var pdpBtn = $(".js__inner-header-fixed").offset().top;
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();

      if (scroll > pdpBtn) {
        $(".js__inner-header-fixed").addClass("fixed");
      } else {
        $(".js__inner-header-fixed").removeClass("fixed");
      }
    });
  } catch (_unused6) {}
  /*Blog content checking if p tag has image then adding class*/


  $(".article-content p").each(function (index) {
    console.log("blog image");

    if ($(this).html().indexOf("<img") > -1) {
      console.log("blog image there");
      $(this).addClass("full-wdith");
    }
  });
  var colorTags = [];
  $('.js__color-tags li').each(function (index, Element) {
    if (jQuery.inArray(this.innerHTML, colorTags) == -1) {
      colorTags.push(this.innerHTML);
    } else {
      $(this).remove();
    }
  });
}); // jQuery(function () {
//   // Get the element
//   for (var i = 0; i < 50; i++) {
//     var marqueeFooter = document.querySelector(".js__marquee p");
//     // Create a copy of it
//     var cloneFooter = marqueeFooter.cloneNode(true);
//     // Inject it into the DOM
//     marqueeFooter.after(cloneFooter);
//   }
// });

jQuery(document).ready(function ($) {
  $(".tab-link").first().addClass("active");
  $(".tab-link").first().addClass("active");
  $(".shopify-section .tab-content").first().show();
  $(".js__dropdown").children("li").children(".tab-link").first().addClass("active");
});
jQuery(document).ready(function ($) {
  $(".filter-btn").first().addClass("active");
  $(".shopify-section .option").first().show();
});
jQuery(document).ready(function ($) {
  $(".filter-btn-mobile").first().addClass("active");
  $(".shopify-section .optionMobile").first().show();
});
"use strict";

jQuery(function () {
  //Nav - Open and Close Mini cart
  if (getglobalLib("Mini_Cart") == "yes") {
    $(".js__cart-expand").on("click", function () {
      if (!$(this).hasClass('cart-page')) {
        $(".js__header-search-section").hide();
        $(this).toggleClass("active");
        $("#CartSidebar").toggleClass("active");
        $("#cart_overlay").toggleClass("active");
      }
    }); // $("#js__cart-close").on("click", function() {
    //     $("#CartSidebar").removeClass("active");
    //     $("#cart_overlay").removeClass("active");
    //     $(".js__cart-expand").removeClass("active");
    // });

    $(".js__cart-expand").attr("href", "javascript:void(0)");
  }
  /* Cart - Free Shipping Progress bar Visiblity */


  if (getglobalLib("Free_Shipping_progressbar") == "yes") {
    $(".js__progressbar_visiblity").removeClass("hide");
  }
  /* Remove mini cart from the cart page */


  if ($(".cart-table-body")[0]) {
    $("#CartSidebar").remove();
    $("#cart_overlay").remove();
    $(".js__cart-expand").removeClass("active");
    $(".js__top-cart-form-actions").remove();
    $(".js__ajax-products-bind").remove();
    $(".mini-cart").removeClass("js__cart-expand");
    $(".mini-cart").attr("href", "/cart");
  }
  /* show no items in cart */


  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
  /*Quantity Plus Minus for the textbox */


  $(".js__product-single__quantity .js__minus-qty").click(function () {
    decreaseQuantity();
  });
  $(".js__product-single__quantity .js__plus-qty").click(function () {
    increaseQuantity();
  });

  function increaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();
    productQuantity++;
    $(".js__quantity-selector").val(productQuantity);
  }

  function decreaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();

    if (productQuantity > 1) {
      productQuantity--;
    }

    $(".js__quantity-selector").val(productQuantity);
  }
});
/* 
  NOTIFICATIONS SECTION
  Show Noticiations On Success and Error
  Note: This function isn't being used in every theme
  Feel free to comment/uncomment as per the functionality
  */

function showCartSuccessMessage() {
  setTimeout(openMiniCart, 500);
  $("#cart-message").addClass("message-success");
  $("#cart-message").removeClass("message-error");
  $("#cart-message").html("Successfully added to cart!");
  $("#cart-message").show();
  setTimeout(function () {
    $("#cart-message").hide();
  }, 5000);
}

function showCartErrorMessage() {
  $("#cart-message").removeClass("message-success");
  $("#cart-message").addClass("message-error");
  $("#cart-message").html("Sorry! Seems like the product is out of stock");
  $("#cart-message").show();
  setTimeout(function () {
    $("#cart-message").hide();
  }, 5000);
}

function openMiniCart() {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    return res.json();
  }).then(function (data) {
    $(".js__cart-expand").addClass("active");
    $("#CartSidebar").addClass("active");
    $("#cart_overlay").addClass("active");
  });
}
/* EVENT: When the cart request is completed everytime the below function is run */


$(document).on("cart.requestComplete", function (event, cart) {
  console.log("On cart request complete");
  reloadAjaxCartItemUsingCartAjaxObject(cart); //Progress Bar of shipping in cart and mini cart; Varies from theme to theme

  progressBar(); //Show and hide empty cart depending upon the cart items

  setTimeout(function () {
    calculateSubTotalWithDiscount();
    addons();
  }, 1000);
}); // $(document).on("cart.requestStarted", function (event, cart) {console.log("Request started"); });
//$(document).on("cart.ready", function (event, cart) {});

/* currency formatter */

/*const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
});*/
"use strict";

jQuery(function () {
  /* Footer - Accordion Visiblity */
  if (getglobalLib("Footer_Accordion") == "yes") {
    $(".js__accordion-toggle-visiblity").addClass("accordion-toggle-footer");
    $(".js__accordion-content-visiblity").addClass("accordion-content-footer");
  }
  /* FAQ - Category Sidebar Visiblity */


  if (getglobalLib("FAQ_Side_Panel") == "yes") {
    $(".js__faq-category-side-panel").removeClass("hide");
  }

  if (getglobalLib("Product_Recommendation_Slider") == "on") {
    var productRecSlider = new Swiper("#js__pdp-recommendation-slider", {
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      clickable: true,
      grabCursor: true,
      mousewheel: true,
      breakpoints: {
        600: {
          slidesPerView: "auto",
          spaceBetween: 20
        },
        601: {
          slidesPerView: "auto",
          spaceBetween: 40
        }
      }
    });
  }
});
"use strict";

jQuery(function () {
  /* Global
  Announcement Slider */
  var announcementSlider = new Swiper(".js__announcement-slider", {
    slidesPerView: 1,
    resistance: false,
    shortSwipes: true,
    loop: false,
    autoHeight: true,
    direction: "vertical",
    autoplay: {
      delay: 6000
    }
  });
  /* Announcement 
  Close on Click  */

  $("#announcement-close").on("click", function () {
    $(".announcement-bar").hide();
    $("body").removeClass("announcement-visible");
  });
  /*  $(document).click(function(e) {
      var container = $(".search-li");
        if (container.css("display") != "none") {
          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0) {
              $(".js__header-search-section").hide();
              $(".js__search").removeClass("active");
          }
      }
    });
  */

  $(".js__search").on("click", function (e) {
    e.preventDefault();

    if ($(".js__cart-expand").hasClass("active") == true) {
      $(".js__cart-expand").removeClass("active");
      $("#CartSidebar").removeClass("active");
      $("#cart_overlay").removeClass("active");
    }

    if ($("#hamburger").hasClass("active") == true) {
      $("#hamburger").removeClass("active");
      $(".outer-wrapper").removeClass("active");
      $("#navbarNavDropdown").removeClass("active");
      $(".js__mobile-menu-open-hide").removeClass("active");
      $(".js__mobile-announcement-text").removeClass("active");
    }

    $(".js__header-search-section").toggle();
    $(".boost-pfs-search-box").focus();
    $(".search-field").focus();

    if ($(".js__search").hasClass("active") == true) {
      $(".js__search").removeClass("active");
      $(".search-results-product").empty();
      $(".search-results-product-outer").hide();
      $(".search-results-other").empty();
      $(".search-results-other-outer").hide();
      $(".search-results-footer").empty();
      $(".search-field").val('');
    } else {
      $(".js__search").addClass("active");
    }
  });
  $(".js__cart-expand").on("click", function (e) {
    e.preventDefault();

    if ($("#hamburger").hasClass("active") == true) {
      $("#hamburger").removeClass("active");
      $(".outer-wrapper").removeClass("active");
      $("#navbarNavDropdown").removeClass("active");
      $(".js__mobile-menu-open-hide").removeClass("active");
      $(".js__mobile-announcement-text").removeClass("active");
    }

    if ($(".js__search").hasClass("active") == true) {
      $(".js__search").removeClass("active");
    }
  });
  /* MEGAMENU
    active link while submenu open */

  if ($(window).width() > 980) {
    $(".has-sub-nav .site-nav__link,.has-sub-nav .sub-nav").mouseover(function () {
      $(".has-sub-nav .site-nav__link").addClass("hover-submenu");

      if ($(".js__search").hasClass("active") == true) {
        $(".js__header-search-section").hide();
        $(".js__search").removeClass("active");
      }

      if ($(".js__cart-expand").hasClass("active") == true) {
        $(".js__cart-expand").removeClass("active");
        $("#CartSidebar").removeClass("active");
        $("#cart_overlay").removeClass("active");
      }

      $(".has-sub-nav .sub-nav").css("visibility", "visible");
      $(".has-sub-nav .sub-nav").css("opacity", "1");
      $(".has-sub-nav .sub-nav").css("z-index", "1");
    });
    $(".has-sub-nav .site-nav__link,.has-sub-nav .sub-nav").mouseout(function () {
      $(".has-sub-nav .site-nav__link").removeClass("hover-submenu");
      $(".has-sub-nav .sub-nav").css("visibility", "hidden");
      $(".has-sub-nav .sub-nav").css("opacity", "0");
      $(".has-sub-nav .sub-nav").css("z-index", "-1");
    });
    $(".has-big-nav .site-nav__link,.has-big-nav .big-nav").mouseover(function () {
      $(".has-big-nav .site-nav__link").addClass("hover-submenu");
      $(".has-big-nav .big-nav").css("visibility", "visible");
      $(".has-big-nav .big-nav").css("opacity", "1");
    });
    $(".has-big-nav .site-nav__link,.has-big-nav .big-nav").mouseout(function () {
      $(".has-big-nav .site-nav__link").removeClass("hover-submenu");
      $(".has-big-nav .big-nav").css("visibility", "hidden");
      $(".has-big-nav .big-nav").css("opacity", "0");
    });
  }
  /* SubMenu
  Accordion JS */


  (function ($) {
    $(function () {
      var navLink = false;
      $(".accordion-toggle").on("mousedown", function (e) {
        "use strict";

        e.stopImmediatePropagation();

        if ($(this).parent("div").hasClass("footer-links")) {
          if ($(window).width() < 980) {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content").slideUp(300);
            } else {
              $(".accordion-toggle").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content").slideUp(300);
              $(this).siblings(".accordion-content").slideDown(300);
            }
          }
        } else {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content").slideUp(300);
          } else {
            $(".accordion-toggle").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content").slideUp(300);
            $(this).siblings(".accordion-content").slideDown(300);
          }
        }

        navLink = true;
      }).focus(function (e) {
        "use strict";

        if (navLink) {
          navLink = false;
        } else {
          if ($(this).parent("div").hasClass("footer-links")) {
            if ($(window).width() < 980) {
              if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).siblings(".accordion-content").slideUp(300);
              } else {
                $(".accordion-toggle").removeClass("active");
                $(this).addClass("active");
                $(".accordion-content").slideUp(300);
                $(this).siblings(".accordion-content").slideDown(300);
              }
            }
          } else {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content").slideUp(300);
            } else {
              $(".accordion-toggle").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content").slideUp(300);
              $(this).siblings(".accordion-content").slideDown(300);
            }
          }
        }
      });
    });
    $(function () {
      var navLink = false;
      $(".accordion-toggle-inner").on("mousedown", function (e) {
        "use strict";

        e.stopImmediatePropagation();

        if ($(this).parent("div").hasClass("footer-links")) {
          if ($(window).width() < 980) {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content-inner").slideUp(300);
            } else {
              $(".accordion-toggle-inner").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content-inner").slideUp(300);
              $(this).siblings(".accordion-content-inner").slideDown(300);
            }
          }
        } else {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content-inner").slideUp(300);
          } else {
            $(".accordion-toggle-inner").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content-inner").slideUp(300);
            $(this).siblings(".accordion-content-inner").slideDown(300);
          }
        }

        navLink = true;
      }).focus(function (e) {
        "use strict";

        if (navLink) {
          navLink = false;
        } else {
          if ($(this).parent("div").hasClass("footer-links")) {
            if ($(window).width() < 980) {
              if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).siblings(".accordion-content-inner").slideUp(300);
              } else {
                $(".accordion-toggle-inner").removeClass("active");
                $(this).addClass("active");
                $(".accordion-content-inner").slideUp(300);
                $(this).siblings(".accordion-content-inner").slideDown(300);
              }
            }
          } else {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content-inner").slideUp(300);
            } else {
              $(".accordion-toggle-inner").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content-inner").slideUp(300);
              $(this).siblings(".accordion-content-inner").slideDown(300);
            }
          }
        }
      });
    });
  })(jQuery);
  /** HEADER **/

  /** Top Search Result Open Close **/


  $("#searchOpen").on("click", function () {
    $(".top-search-results").toggleClass("active");
  });
});
/** Fix Header on Scroll **/

$(window).scroll(function () {
  var sticky = $(".js__main-header"),
      scroll = $(window).scrollTop();

  if (scroll >= 35) {
    sticky.addClass("fixed");
    $("body").addClass("header-fixed");
    $(".main-content").addClass("active");
  } else {
    $("body").removeClass("header-fixed");
    sticky.removeClass("fixed");
    $(".main-content").removeClass("active");
  }
});
/** used when header is relative **/

/** Mobile Navigation Open Close **/

(function ($) {
  $(function () {
    var navLink = false;
    $("#hamburger").mousedown(function (e) {
      $(this).toggleClass("active");
      $(".outer-wrapper").toggleClass("active");
      $("#navbarNavDropdown").toggleClass("active");
      $(".js__mobile-menu-open-hide").toggleClass("active");
      $(".js__mobile-announcement-text").toggleClass("active");

      if ($(".js__search").hasClass("active") == true) {
        $(".js__header-search-section").hide();
        $(".js__search").removeClass("active");
      }

      if ($(".js__cart-expand").hasClass("active") == true) {
        $(".js__cart-expand").removeClass("active");
        $("#CartSidebar").removeClass("active");
        $("#cart_overlay").removeClass("active");
      }

      if ($("#navbarNavDropdown").hasClass("active")) {
        if ($(window).width() < 981) {
          $("body").css("overflow-y", "hidden");
          $("body").addClass("scroll-stop");
        } else {
          $("body").removeClass("scroll-stop");
          $("body").css("overflow-y", "initial");
        }

        $(".js__logo").addClass("active");
      } else {
        $(".js__logo").toggleClass("active");
        $("body").css("overflow-y", "initial");
      }

      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        $(this).toggleClass("active");
        $("#navbarNavDropdown").toggleClass("active");
        $(".js__mobile-menu-open-hide").toggleClass("active");
        $(".js__mobile-announcement-text").toggleClass("active");

        if ($("#navbarNavDropdown").hasClass("active")) {
          $(".js__logo").addClass("active");
        } else {
          $(".js__logo").toggleClass("active");
        }
      }
    });
  });
})(jQuery);
/** CART SIDEBAR
 * Close on Outside Click
 * **/

/*$("body").click(function(e) {
    var popup = $("#CartSidebar");
    var overlay = $("#cart_overlay");
    var button = $(".js__cart-expand");
    if ((popup.is(e.target)) && popup.has(e.target).length == 0) {

        popup.removeClass("active");
        overlay.removeClass("active");
        $(".js__cart-expand").removeClass("active");
    }
});
*/


jQuery(function () {
  $("body").on('click', function (e) {
    console.log("a");

    if (!($(e.target).closest("#CartSidebar").length > 0 || $(e.target).closest(".js__cart-expand").length > 0)) {
      var popup = $("#CartSidebar");
      $(".js__cart-expand").removeClass("active");
      popup.removeClass("active");
      $("body").removeClass("fixed"); // $(".js__secondary-nav").css("z-index", "9");
      // $("#shopify-section-header").css("z-index", "9");
    }

    if (!($(e.target).closest(".js__search").length > 0 || $(e.target).closest(".js__header-search-section").length > 0)) {
      $(".top-search-results").removeClass("active");
      $(".js__search").removeClass("active");
      $(".js__header-search-section").hide();
      $(".search-results-product").empty();
      $(".search-results-product-outer").hide();
      $(".search-results-other").empty();
      $(".search-results-other-outer").hide();
      $(".search-results-footer").empty();
      $(".search-field").val('');
    }

    if (!($(e.target).closest("#hamburger").length > 0 || $(e.target).closest(".navbar-collapse").length > 0)) {
      $("#hamburger").removeClass("active");
      $(".outer-wrapper").removeClass("active");
      $("#navbarNavDropdown").removeClass("active");
      $(".js__mobile-menu-open-hide").removeClass("active");
      $(".js__mobile-announcement-text").removeClass("active");
    }
  });
});
"use strict";

var pdpThumbnail;
var pdpSlider;
var pdpPopupThumbnail;
var pdpPopupSlider;
$(document).ready(function ($) {
  /*Slider working Start*/

  /* Main SLIDER  initialization */

  /*  $(".pdp-slider")
        .not(".slick-initialized")
        .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            focusOnSelect: true,
            infinite: false,
            adaptiveHeight: false,
            variableWidth: false
        });
          
    if (getglobalLib("PDP_Slider_Thumbnail") == "vertical") {
        $(".js__pdp-thumbnail-slider")
            .not(".slick-initialized")
            .slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: false,
                centerMode: false,
                infinite: false,
                focusOnSelect: true,
                focusOnChange: false,
                variableWidth: false,
                verticalSwiping: true,
                vertical: true,
               
                arrows: true,
                responsive: [{
                        breakpoint: 981,
                        settings: {
                            verticalSwiping: false,
                            vertical: false,
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            verticalSwiping: false,
                            vertical: false,
                            variableWidth: true,
                        },
                    },
                ],
            });
    } else {
        $(".js__pdp-thumbnail-slider")
            .not(".slick-initialized")
            .slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                dots: false,
                centerMode: false,
                infinite: false,
                arrows: false,
                focusOnSelect: true,
                variableWidth: false,
              
                responsive: [{
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                    },
                }, ],
            });
    }
    */

  /* pdpPopupThumbnail = new Swiper(".js__pdp-popup-thumbnail-slider", {
         slidesPerView: 'auto',
             breakpoints: {
           980: {
               slidesPerView: "auto",
               direction: "horizontal",
             },
           981: {
               slidesPerView: 'auto',
               direction: "vertical",
           },
       },
     });*/
  pdpPopupSlider = new Swiper(".js__pdp-popup-slider", {
    slidesPerView: 1
    /*  thumbs: {
          swiper: pdpPopupThumbnail,
      },*/

  });
  pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
    slidesPerView: "auto",
    spaceBetween: 11
  });
  pdpSlider = new Swiper(".js__pdp-slider", {
    slidesPerView: 1,
    spaceBetween: 11,
    thumbs: {
      swiper: pdpThumbnail
    }
  });
  var swiperNextCount = 0;
  $(document).on("click", ".swiper-button-next-pdp.swiper-button-disabled", function (e) {
    var count = 1;
    swiperNextCount++;

    if (swiperNextCount == 2) {
      console.log("swiper-button-disabled");
      $(".js__pdp-thumbnail  .swiper-slide").each(function (index) {
        console.log(count);

        if (count == 1) {
          var slideno = parseInt($(this).attr("aria-label").split("/")[0].trim()) - 1;
          pdpThumbnail.slideTo(slideno, 500, true);
          swiperNextCount = 0;
        }

        count++;
      });
    }
  });
  /*PDP tab section drop down change*/

  $(".js__pdp-tab-select").change(function () {
    $(".tab-content").removeClass("active");
    $(".tab-content").hide();
    $("#" + $(this).val()).show();
    $("#" + $(this).val()).addClass("active");
    $(".tab-link").removeClass("active");
    $("#tab-link-" + $(this).val()).addClass("active");
  });
  /* Manual click of thumbnail of slider*/

  $(document).on("click", ".pdp-thumbnail .swiper-slide", function (e) {
    console.log("edeefeff");
    e.preventDefault();
    var slideno = parseInt($(this).attr("aria-label").split("/")[0].trim()) - 1;
    $(".pdp-thumbnail .swiper-slide").removeClass("active");
    $(this).addClass("active");
    pdpSlider.slideTo(slideno, 500, true); // $(".pdp-slider").slick("slickGoTo", slideno);
  });
  /*Write review click*/

  $(".js__write-review-btn").click(function () {
    var target = $(".pdp-review-widget");
    setTimeout(function () {
      $("html, body").animate({
        scrollTop: target.offset().top - 200
      }, 500);
    }, 500);
  });
  /*View details*/

  $(document).on("click", ".js__pdp-show-more", function (e) {
    e.preventDefault();
    setTimeout(function () {
      var target = $(".js__desciption");
      $("html, body").animate({
        scrollTop: target.offset().top - 350
      }, 500);
    }, 500);
  });
  /*Slider working End*/

  /* Call page load functions */

  setTimeout(function () {
    setColorThumbImages();
  }, 1000);
  /* FORMATTING: Loop Through each color thumb and set the images for them through the product color library object */

  function setColorThumbImages() {
    if ($(".js-variant-color-swatch li")[0]) {
      $(".js-variant-color-swatch  li").each(function (index) {
        var color = $(this).attr("data-color");
        var colorValue = getVariantColor(color); //$(this).children("div.color").css("background-color", colorValue);

        if (colorValue == "") {
          $(this).children("img").css("opacity", "0");
        }

        $(this).children("img").attr("src", colorValue);
      });
    }
  }
});
/*PENDING Get Variant Color*/

function getVariantColor(color) {
  try {
    var variantColorValue = "";
    $.each(prodColor, function (key, value) {
      if (color.toLowerCase() == value.title.toLowerCase()) {
        variantColorValue = value.color;
      }
    });
    /* $.each(prodLib, function (key, value) {
       if (color.toLowerCase() == value.option1.toLowerCase()) {
         variantColorValue = value.image;
       }
     });*/

    return variantColorValue;
  } catch (_unused) {}
}
/* Color swatch click*/


$(document).ready(function ($) {
  $(document).on("mouseenter", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var variantImage = $(this).attr("data-image");
    var featuredImage = $(this).attr("data-featured_image");

    if (variantImage.indexOf("no-image-") == -1) {
      $(".js__product-image-" + productID).attr("src", variantImage);
    } else {
      $(".js__product-image-" + productID).attr("src", featuredImage);
    }
  });
  $(document).on("mouseleave", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var featuredImage = $(".js__product-image-" + productID).attr("data-src");
    $(".js__product-image-" + productID).attr("src", featuredImage);
  });
  /*Click of image open popup*/

  $(document).on("click", ".js__pdp-images .slide, .js__pdp-popup-thumbnail-slider .slide", function () {
    var slideno = $(this).index(); //pdpPopupThumbnail.slideTo(slideno, 10, true);

    pdpPopupSlider.slideTo(slideno, 10, true);
    pdpThumbnail.slideTo(slideno, 10, true);
    pdpSlider.slideTo(slideno, 10, true);
    setTimeout(function () {
      $("#shopify-section-header").css("opacity", "0");
      $("#shopify-section-header").css("z-index", "-1");
      $(".js__modal-product-image").show();
      $("body").css("overflow", "hidden");
      $("#PageContainer").css("z-index", "99");
    }, 500); // $(".js__pdp-thumbnail-slider slide:nth-child(" + slideno + ")").click();
  });
  $(document).on("click", ".js__pdp-more-images", function () {
    var slideno = 6; //pdpPopupThumbnail.slideTo(slideno, 10, true);

    pdpPopupSlider.slideTo(slideno, 10, true);
    pdpThumbnail.slideTo(slideno, 10, true);
    pdpSlider.slideTo(slideno, 10, true);
    setTimeout(function () {
      $("#shopify-section-header").css("opacity", "0");
      $("#shopify-section-header").css("z-index", "-1");
      $(".js__modal-product-image").show();
      $("body").css("overflow", "hidden");
      $("#PageContainer").css("z-index", "99");
    }, 500);
  });
  $(document).on("click", ".js__modal-product-image-close", function () {
    $(".js__modal-product-image").hide();
    $("#shopify-section-header").css("opacity", "1");
    $("#shopify-section-header").css("z-index", "9");
    $("#PageContainer").css("z-index", "inherit");
    $("body").css("overflow", "inherit");
  });
  /*Info popup click*/

  $(document).on("click", ".js__variant-info-popup", function () {
    var position = $(this).attr("data-attr");
    setTimeout(function () {
      $(".js__secondary-nav").css("z-index", "4");
      $(".js__popup-modal-varaint-" + position).show(); //  $("body").addClass("fixed");
    }, 500);
  });
  $(".popup-modal-varaint").on('click', function (e) {
    if (!($(e.target).closest(".modal-content").length > 0 || $(e.target).closest(".close").length > 0)) {
      $(this).hide();
      $("body").removeClass("fixed");
      $(".js__secondary-nav").css("z-index", "9");
      $("#shopify-section-header").css("z-index", "9");
    }
  });
  $(document).on("click", ".js__close_popup-modal-varaint", function () {
    $(".js__popup-modal-varaint").hide();
    $("body").removeClass("fixed");
    $(".js__secondary-nav").css("z-index", "9");
    $("#shopify-section-header").css("z-index", "9");
  });
  $(document).on("click", ".js__measurements-info-popup", function () {
    setTimeout(function () {
      $("#shopify-section-header").css("z-index", "-1");
      $(".js__secondary-nav").css("z-index", "4");
      $(".js__popup-modal-measurements").show();
      $("body").addClass("fixed");
    }, 500);
  });
  $(document).on("click", ".js__close_popup-modal-measurements", function () {
    $(".js__popup-modal-measurements").hide();
    $("body").removeClass("fixed");
    $(".js__secondary-nav").css("z-index", "9");
    $("#shopify-section-header").css("z-index", "9");
  });
  $(document).on("click", ".js__measurements-btn", function () {
    var type = $(this).attr("data-attr");
    var typeShow = $(this).attr("data-attr-show");
    $(".js__measurements-content").hide();
    $(".js__measurements-content-" + type).show();
    $(".js__measurements-btn").hide();
    $(".js__measurements-btn-" + typeShow).show();
  });
  /*Product description*/

  var productDesc = $(".js__desciption").html();

  try {
    var productDescWords = productDesc.trim().split(" ");

    if (productDescWords.length > 40) {
      $(".js__pdp-show-more").css("display", "inline-block");
    }
  } catch (_unused2) {}

  try {
    var topHeight = parseFloat($(".js__secondary-pdp-nav").height());
    topHeight = topHeight + 51;
    $(".infographics-section").find(".tooltip-popup").css("top", topHeight + "px");
    $(window).resize(function () {
      var topHeight = parseFloat($(".js__secondary-pdp-nav").height());
      topHeight = topHeight + 51;
      $(".infographics-section").find(".tooltip-popup").css("top", topHeight + "px");
    });
  } catch (_unused3) {}
});
"use strict";

var colorSelected = "";
var secondOptionVariantValue = "";
var thirdOptionVariantValue = "";
var selectedVariantID;
$(document).ready(function ($) {
  /* if no varient then active class added in product image section*/
  try {
    if (prodLib.length == 0) {
      $(".js-pdp-media").addClass("active");
      $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
    }
  } catch (_unused) {}

  var colorPosition = $("#colorPosition").val();
  var numberOfAvailableOptions = parseInt($("#optionSize").val()); // on page load check the color position, and set 2nd and 3rd options values

  checkColorPosition();

  function checkColorPosition() {
    getColorPosition();
    /* 
    if only color and no other options
    */

    if (colorPosition != undefined && numberOfAvailableOptions == 1) {
      SoldOutUnavailableOnColorSwatches(colorSelected);
    }
  }
  /*
  PENDING Merge  - Plus and Minus
  */

  /*Quantity Plus Minus*/


  $(".js-product-single__quantity .js-plus-minus-qty").click(function () {
    var type = $(this).attr("data-type");
    var productQuantity = $(".js-quantity-selector").val();

    if (type == "minus") {
      if (productQuantity > 1) {
        productQuantity--;
      }
    } else {
      productQuantity++;
    }

    $(".js-quantity-selector").val(productQuantity);
  }); // On DD change, fire the form DD element and also run the soldoutColorSwatches function
  // $(".js__pdp-variant-select").change(function () {

  $(".js__pdp-variant-select").change(function () {
    var optionIndex = $(this).attr("data-option");
    var optionValue = $(this).val();
    var optionType = $(this).attr("data-type");
    $("#product .product__form .options .option.option-" + optionIndex + " .label span").text(optionValue);

    if (optionType.toLowerCase().indexOf("monogramming") > -1) {
      if (optionValue.toLowerCase() == "add a monogram") {
        if ($("#add-a-monogram").val() == undefined) {
          $(this).parent("ul").parent(".variant-option").append('<input placeholder="type your personalization" id="add-a-monogram" class="js__text-personalization" value="" type="text" name="properties[Monogram Message]">');
        }
      } else {
        $("#add-a-monogram").remove();
      }
    }

    if (optionType.toLowerCase().indexOf("engraving") > -1 || optionType.toLowerCase().indexOf("personalization") > -1) {
      if (optionValue.toLowerCase() != "no engraving") {
        $("#add-a-engraving").remove();
        $(this).parent("ul").parent(".variant-option").append('<input placeholder="type your personalization" id="add-a-engraving" class="js__text-personalization" value="" type="text" name="properties[Engraving Message]">');
      } else {
        $("#add-a-engraving").remove();
      }
    }

    try {
      SoldOutUnavailableOnColorSwatches(colorSelected);
    } catch (_unused2) {} // button  - Sold out and add to cart


    $("#product-select-option-" + optionIndex).val(optionValue).trigger("change"); //color swatch - sold out working

    /*Checking if this is filter type then image filter code will work*/

    var OptionType = $(this).attr("data-type");
    var FilterType = $("#variantFilterType").val().split("|");

    for (var k = 0; k < FilterType.length; k++) {
      if (OptionType == FilterType[k]) {
        imageFilter(optionValue);
      }
    }
  });
  $(document).on("click", ".js__pdp-variant-select li", function () {
    var optionIndex = $(this).attr("data-option");
    var optionValue = $(this).attr("data-value");
    var optionType = $(this).parent("ul").attr("data-type");
    $(this).parent("ul").children("li").removeClass("active");
    $(this).addClass("active");
    $("#product-select-option-" + optionIndex).val(optionValue).trigger("change");
    $("#product .product__form .options .option.option-" + optionIndex + " .label span").text(optionValue); // button  - Sold out and add to cart

    if (optionType.toLowerCase().indexOf("monogramming") > -1) {
      if (optionValue.toLowerCase() == "add a monogram") {
        if ($("#add-a-monogram").val() == undefined) {
          $(this).parent("ul").parent(".variant-option").append('<input placeholder="type your personalization" id="add-a-monogram" value="" class="js__text-personalization" type="text" name="properties[Monogram Message]">');
        }
      } else {
        $("#add-a-monogram").remove();
      }
    }

    if (optionType.toLowerCase().indexOf("engraving") > -1 || optionType.toLowerCase().indexOf("personalization") > -1) {
      if (optionValue.toLowerCase() != "no engraving") {
        $("#add-a-engraving").remove();
        $(this).parent("ul").parent(".variant-option").append('<input placeholder="type your personalization" id="add-a-engraving" value="" class="js__text-personalization" type="text" name="properties[Engraving Message]">');
      } else {
        $("#add-a-engraving").remove();
      }
    }

    try {
      SoldOutUnavailableOnColorSwatches(colorSelected);
    } catch (_unused3) {} //color swatch - sold out working


    imageFilter();
  });
  $(".js__color-swatches").click(function () {
    // remove active class - from all the li's
    $('.js__color-swatches').removeClass('active'); // add class on the one which is clicked

    $(this).addClass('active');
    var optionindex = $(this).data('option');
    var thevalue = $(this).data('value');
    var typevalue = $(this).data('type-value');
    $(".js__color-swatches[data-type-value=" + typevalue + "]").addClass('active'); //show the selected value

    $('.variant-option.option-' + optionindex + ' .label span').text(thevalue);

    if ($(this).hasClass('swatch')) {
      colorSelected = thevalue;
    }
    /*Checking if this is filter type then image filter code will work*/


    var OptionType = $(this).attr("data-type"); // trigger change

    $('#product-select-option-' + optionindex).val(thevalue).trigger('change');
    imageFilter();
  });
  /*Run this function when image change on variant click*/

  function imageFilter() {
    var FilterType = $("#variantFilterType").val().split("|");
    var selectedValue = "";
    $(".selector-wrapper").each(function (index) {
      var optionType = $(this).find("label").html();
      var optionValue = $(this).find("select").val();

      for (var k = 0; k < FilterType.length; k++) {
        if (FilterType[k].toLowerCase() == optionType.toLowerCase()) {
          if (selectedValue == "") {
            selectedValue = optionValue;
          } else {
            selectedValue = selectedValue + " " + optionValue;
          }
        }
      }
    });
    console.log("selectedValue" + selectedValue);

    try {
      /*Slick slider filter on swatch click*/
      var thumbColorSelected = selectedValue.replace(" ", "-");
      thumbColorSelected = thumbColorSelected.replace(/[^a-zA-Z0-9 ]/g, "-");
      thumbColorSelected = thumbColorSelected.replace(/ /g, "-");
      thumbColorSelected = thumbColorSelected.replace(/--/g, "-");
      thumbColorSelected = thumbColorSelected.replace(/---/g, "-");
      console.log("thumbColorSelected" + thumbColorSelected);
      $(".js__pdp-images-hidden").find(".all").addClass(thumbColorSelected.toLowerCase());
      $(".js__pdp-images-hidden").find(".slide").addClass("remove-slide");
      $(".js__pdp-images-hidden").find("." + thumbColorSelected.toLowerCase()).removeClass("remove-slide");
      $(".js__pdp-thumbnail-slider").children(".swiper-wrapper").empty();
      $(".js__pdp-slider").children(".swiper-wrapper").empty();
      $(".js__pdp-popup-thumbnail-slider").children(".swiper-wrapper").empty();
      $(".js__pdp-popup-slider").children(".swiper-wrapper").empty();
      $(".js__pdp-images").empty();
      $(".js__pdp-images-hidden  .slide").each(function (index) {
        if ($(this).hasClass('remove-slide')) {} else {
          $(".js__pdp-images").append($(this).clone());
          $(".js__pdp-slider").children(".swiper-wrapper").append($(this).clone());
          $(".js__pdp-thumbnail-slider").children(".swiper-wrapper").append($(this).clone());
          $(".js__pdp-popup-slider").children(".swiper-wrapper").append($(this).clone());
          $(".js__pdp-popup-thumbnail-slider").children(".swiper-wrapper").append($(this).clone());

          if ($(".js__pdp-images div").length > 5) {
            $(".js__pdp-more-images").show();
          } else {
            $(".js__pdp-more-images").hide();
          }
        }
      }); // pdpPopupThumbnail.destroy();

      pdpPopupSlider.destroy();
      pdpThumbnail.destroy();
      pdpSlider.destroy();
      pdpPopupSlider = new Swiper(".js__pdp-popup-slider", {
        slidesPerView: 1
        /*  thumbs: {
              swiper: pdpPopupThumbnail,
          },*/

      });
      pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
        slidesPerView: "auto",
        spaceBetween: 11
      });
      pdpSlider = new Swiper(".js__pdp-slider", {
        slidesPerView: 1,
        spaceBetween: 11,
        thumbs: {
          swiper: pdpThumbnail
        }
      });
      /*Selected first variant image in slider which have no all class*/

      var boolVariantFirstImage = false;
      $(".js__pdp-thumbnail-slider  li").each(function () {
        if (!$(this).hasClass("all")) {
          if (boolVariantFirstImage == false) {
            $(this).click();
            $(this).addClass("active");
            boolVariantFirstImage = true;
            console.log(boolVariantFirstImage);
          }
        }
      });
      /*When we dont have any variant image*/

      console.log(boolVariantFirstImage);

      if (boolVariantFirstImage == false) {
        $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
        $(".js__pdp-thumbnail-slider li:first-child").click();
      }

      colorSelected = selectedValue;
    } catch (_unused4) {}
  }

  $(".js__pdp-variant-select li.active").click(); // main sold out and unavailable working

  function SoldOutUnavailableOnColorSwatches(colorSelected) {
    getColorPosition(); // Remove out of stock and unavailable from color swatches

    $(".js__color-swatches").removeClass("out-of-stock");
    $(".js__color-swatches").removeClass("unavailable");
    var colorLength = $(".js__color-swatches").length;
    var colorCount = 1;
    /*
    Loop Through each input radio for the color
    */
    // we are using color swatch working for other options when they are radio buttons

    $(".js__color-swatches").each(function (index) {
      var colorValue = $(this).attr("data-value");
      var checkColorOptionExists = false;
      /* 
       Loop through product library object for variant 
       and if variant select matches and quantity = 0 then show out of stock message
       */

      /*
      PENDING - Merge - ProdLib Each Function
      */

      $.each(prodLib, function (key, value) {
        var itemQuantity = value.quantity;
        var itemAvailable = value.available;
        var prodColorOptionValue = "";
        var prodSecondOptionValue = "";
        var prodThirdOptionValue = "";

        if (colorPosition == "1") {
          prodColorOptionValue = value.option1;
          prodSecondOptionValue = value.option2;
          prodThirdOptionValue = value.option3;
        }

        if (colorPosition == "2") {
          prodColorOptionValue = value.option2;
          prodSecondOptionValue = value.option1;
          prodThirdOptionValue = value.option3;
        }

        if (colorPosition == "3") {
          prodColorOptionValue = value.option3;
          prodSecondOptionValue = value.option1;
          prodThirdOptionValue = value.option2;
        }

        console.log("prodSecondOptionValue" + prodSecondOptionValue);
        console.log("secondOptionVariantValue" + secondOptionVariantValue);
        var colorOption = prodColorOptionValue.toLowerCase();
        colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-"); // Pending - Reduce these 3 lines

        colorOption = colorOption.replace(/ /g, "-");
        colorOption = colorOption.replace(/--/g, "-");
        colorOption = colorOption.replace(/---/g, "-");
        /*Checking each color  size quantity and which have 0 then added out of stock class*/

        if (numberOfAvailableOptions == 3) {
          /*three matching option checking quantity if 0 then showing out of stock */
          if (secondOptionVariantValue.toLowerCase() == prodSecondOptionValue.toLowerCase() && thirdOptionVariantValue.toLowerCase() == prodThirdOptionValue.toLowerCase()) {
            {
              //check if quantity>1 then set the color swatch - Out of stock
              setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
            }
          }
        } else if (numberOfAvailableOptions == 2) {
          /*two matching option checking quantity if 0 then showing out of stock */
          if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
            {
              //check if quantity>1 then set the color swatch - Out of stock
              setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
            }
          }
        } else {
          //check if quantity>1 then set the color swatch - Out of stock
          setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
        }

        if (prodColorOptionValue == colorValue) {
          if (numberOfAvailableOptions == 3) {
            if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase() && prodThirdOptionValue.toLowerCase() == thirdOptionVariantValue.toLowerCase()) {
              checkColorOptionExists = true;
            }
          } else if (numberOfAvailableOptions == 2) {
            if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
              checkColorOptionExists = true;
            }
          } else {
            checkColorOptionExists = true;
          }
        }
      });

      if (checkColorOptionExists == false) {
        var colorOption = colorValue;
        colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
        colorOption = colorOption.replace(/ /g, "-");
        colorOption = colorOption.replace(/--/g, "-");
        colorOption = colorOption.replace(/---/g, "-");
        colorOption = colorOption.toLowerCase();
        $(".js__color-swatches[data-type-value=" + colorOption + "]").removeClass("out-of-stock");
        $(".js__color-swatches[data-type-value=" + colorOption + "]").addClass("unavailable");

        if ($(".js__color-swatches[data-type-value=" + colorOption + "]").hasClass("active")) {
          var nextColor = colorCount + 1;

          if (colorCount < colorLength) {
            $(".js__color-swatches:nth-child(" + nextColor + ")").click();
          } else {
            $(".js__color-swatches:nth-child(1)").click();
          }
        }
      }

      colorCount++;
    });
  }

  function getColorPosition() {
    if (colorPosition != undefined && numberOfAvailableOptions > 1) {
      if (colorPosition == "1") {
        secondOptionVariantValue = $("#product-select-option-1").val();

        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $("#product-select-option-2").val();
        }
      }

      if (colorPosition == "2") {
        secondOptionVariantValue = $("#product-select-option-0").val();

        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $("#product-select-option-2").val();
        }
      }

      if (colorPosition == "3") {
        secondOptionVariantValue = $("#product-select-option-0").val();

        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $("#product-select-option-1").val();
        }
      }
    } else {
      secondOptionVariantValue = $("#product-select-option-0").val();

      if (numberOfAvailableOptions > 1) {
        thirdOptionVariantValue = $("#product-select-option-1").val();
      }
    }

    try {
      colorSelected = colorSelected.toLowerCase();
    } catch (_unused5) {}
  }

  function setColorSwatchOutofStock(prodColor, prodQuantity, prodAvailability) {
    if (prodQuantity < 1 && prodAvailability == "false") {
      $(".js__color-swatches[data-type-value=" + prodColor + "]").addClass("out-of-stock");
    }
  }

  setTimeout(function () {
    $(".js__pdp-variant-select li.active").click();
    $(".js__pdp-variant-select").change();
    $(".js__color-swatches.active").click();
  }, 1000);
});
"use strict";

// if (item.type == "product") { has no data then don't bind anything.
$(function () {
  var currentAjaxRequest = null;
  var searchForms = $('form[action="/search"]').css('position', 'relative').each(function () {
    var input = $(this).find('input[name="q"]');
    input.attr('autocomplete', 'off').bind('keyup change', function () {
      var term = $(this).val();
      var form = $(this).closest('form');
      $(".js__header-search-section").addClass("active");
      var searchURL = '/search?type=all&q=*' + term + '*';
      var resultsList = $('.search-results');

      if (term.length > 0 && term !== $(this).attr('data-old-term')) {
        $(this).attr('data-old-term', term);
        if (currentAjaxRequest !== null) currentAjaxRequest.abort();
        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function (data) {
          // Clear existing content
          console.log(data);
          resultsList.html(''); // Check if containers exist, if not, create them

          var productContainerOuter = $('<div class="search-results-product-outer" style="display:none"></div>');
          var productContainer = $('<ul class="search-results-product flex-wrap"></ul>');
          var otherContainerOuter = $('<div class="search-results-other-outer" style="display:none"></div>');
          var otherContainer = $('<ul class="search-results-other flex-wrap"></ul>');
          var footerContainer = $('<div class="search-results-footer"></div>');

          if (data.results_count === 0) {
            resultsList.html('<p>No results.</p>').fadeIn(200);
            console.log("No results found.");
          } else {
            console.log(data.results);
            var otherImage = $(".js__hidden-search-other-image").html();
            $.each(data.results, function (index, item) {
              var link = $('<a></a>').attr('href', item.url);
              var contentDiv = $('<div class="product-card"></div>'); // Common container

              if (item.type == "product") {
                contentDiv.append('<div class="image-section"><img src="' + item.thumbnail + '" /></div>');
                contentDiv.append('<h6 class="product-card__product-title">' + item.title + '</h6>');
                productContainer.append($('<li></li>').append(link.append(contentDiv)));
              } else if (item.type == "article") {
                // Display article image here
                var articleImage = item.articleThumbnail && item.articleThumbnail.includes('no-image-') === false ? '<div class="image-section"><img src="' + item.articleThumbnail + '" class="article-image" /></div>' : '<div class="image-section"><img src="' + otherImage + '" /></div>';
                contentDiv.append(articleImage);
                contentDiv.append('<h6 class="product-card__product-title">' + item.title + '</h6>');
                otherContainer.append($('<li></li>').append(link.append(contentDiv)));
              } else {
                contentDiv.append('<div class="image-section"><img src="' + otherImage + '" /></div>');
                contentDiv.append('<h6 class="product-card__product-title">' + item.title + '</h6>');
                otherContainer.append($('<li></li>').append(link.append(contentDiv)));
              }
            }); // Display results containers only when there is data

            if (productContainer.children().length > 0) {
              productContainerOuter.append('<h4>Product</h4>').append(productContainer);
              resultsList.append(productContainerOuter.hide());
            }

            if (otherContainer.children().length > 0) {
              otherContainerOuter.append('<h4>Blog/Pages</h4>').append(otherContainer);
              resultsList.append(otherContainerOuter.hide());
            }

            if (data.results_count > 10) {
              footerContainer.append('<ul><li class="view-more-section"><a class="btn" href="' + searchURL + '"> +(' + data.results_count + ') more</a></li></ul>');
              resultsList.append(footerContainer);
            } // Fade in all containers


            resultsList.children().fadeIn(200);
          }
        });
      }
    });
  }); // Clicking outside makes the results disappear.
  //    $('body').bind('click', function(){
  //      $('.search-results').hide();
  //    });
});